import {
  EmptySerializersModule991ju6pz9b79 as EmptySerializersModule,
  Decoder23nde051s631g as Decoder,
  CompositeDecoder2tzm7wpwkr0og as CompositeDecoder,
  SerializerFactory1qv9hivitncuv as SerializerFactory,
  serializer1x79l67jvwntn as serializer,
  InlinePrimitiveDescriptor3i6ccn1a4fw94 as InlinePrimitiveDescriptor,
  SEALED_getInstance2brzxtciy6zxg as SEALED_getInstance,
  buildSerialDescriptor2873qmkp8r2ib as buildSerialDescriptor,
  KSerializerzf77vz1967fq as KSerializer,
  MapSerializer11kmegt3g5c1g as MapSerializer,
  SerialDescriptor2pelqekb5ic3a as SerialDescriptor,
  ListSerializer1hxuk9dx5n9du as ListSerializer,
  STRING_getInstance2md3nu8ka1da4 as STRING_getInstance,
  ENUM_getInstance3qjro8veu1n4s as ENUM_getInstance,
  PrimitiveSerialDescriptor3egfp53lutxj2 as PrimitiveSerialDescriptor,
  serializer2lw83vwvpnyms as serializer_0,
  get_isNullable36pbikm8xb7bz as get_isNullable,
  get_isInline5x26qrhi9qs6 as get_isInline,
  get_annotationshjxdbdcl8kmv as get_annotations,
  Encoderqvmrpqtq8hnu as Encoder,
  CompositeEncoderknecpkexzn3v as CompositeEncoder,
  ElementMarker33ojvsajwmzts as ElementMarker,
  SerializationExceptioneqrdve3ts2n9 as SerializationException,
  CLASS_getInstanceycyg9nehd7tt as CLASS_getInstance,
  LIST_getInstance31r89469rgwkw as LIST_getInstance,
  SealedClassSerializeriwipiibk55zc as SealedClassSerializer,
  jsonCachedSerialNameslxufy2gu43jt as jsonCachedSerialNames,
  ENUMlmq49cvwy4ow as ENUM,
  PrimitiveKindndgbuh6is7ze as PrimitiveKind,
  PolymorphicKindla9gurooefwb as PolymorphicKind,
  CONTEXTUAL_getInstance3iftz58z4hzud as CONTEXTUAL_getInstance,
  MAP_getInstance242ky2ofgg8p5 as MAP_getInstance,
  contextual3hpp1gupsu4al as contextual,
  SerializersModuleCollector3dddz14wd7brg as SerializersModuleCollector,
  AbstractDecoder35guh02ubh2hm as AbstractDecoder,
  AbstractPolymorphicSerializer1ccxwp48nfy58 as AbstractPolymorphicSerializer,
  DeserializationStrategy1z3z5pj9f7zc8 as DeserializationStrategy,
  findPolymorphicSerializer1nm87hvemahcj as findPolymorphicSerializer,
  MissingFieldException24tqif29emcmi as MissingFieldException,
  AbstractEncoder2gxtu3xmy3f8j as AbstractEncoder,
  OBJECT_getInstanceoefnxtom5aro as OBJECT_getInstance,
  findPolymorphicSerializerk638ixyjovk5 as findPolymorphicSerializer_0,
  SerializationStrategyh6ouydnm6hci as SerializationStrategy,
  serializer3ikrxnm8b29d6 as serializer_1,
  serializer36584sjyg5661 as serializer_2,
  serializer1q7c5q67ysppr as serializer_3,
  NamedValueDecoderzk26ztf92xbq as NamedValueDecoder,
  getContextualDescriptor2n1gf3b895yb8 as getContextualDescriptor,
} from './kotlinx-serialization-kotlinx-serialization-core.mjs';
import {
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  VOID7hggqo3abtya as VOID,
  Unit_instanceat14thlj150z as Unit_instance,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  IllegalArgumentException2asla15b5jaob as IllegalArgumentException,
  toString1pkumu07cwy4m as toString,
  charSequenceLength3278n89t01tmv as charSequenceLength,
  charSequenceGet1vxk1y5n17t1z as charSequenceGet,
  _Char___init__impl__6a9atx367vrx0avsvbg as _Char___init__impl__6a9atx,
  equals2au1ep9vhcato as equals,
  toString30pk9tzaqopn as toString_0,
  Enum3alwj03lh1n41 as Enum,
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  StringBuildermazzzhj6kkai as StringBuilder,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  hashCodeq5arwsb9dgti as hashCode,
  joinToString1cxrrlmo0chqs as joinToString,
  KtMap140uvy3s5zad8 as KtMap,
  LazyThreadSafetyMode_PUBLICATION_getInstance23f213579at67 as LazyThreadSafetyMode_PUBLICATION_getInstance,
  lazy1261dae0bgscp as lazy,
  getKClassFromExpression3vpejubogshaw as getKClassFromExpression,
  getBooleanHashCode1bbj3u6b3v0a7 as getBooleanHashCode,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  KtList3hktaavzmj137 as KtList,
  NumberFormatException3bgsm2s9o4t55 as NumberFormatException,
  numberRangeToNumber25vse2rgp6rs8 as numberRangeToNumber,
  ClosedRangehokgr73im9z3 as ClosedRange,
  isInterface3d6p8outrmvmk as isInterface,
  contains2c50nlxg7en7o as contains,
  toDouble1kn912gjoizjp as toDouble,
  StringCompanionObject_instance1kavzb69ik84p as StringCompanionObject_instance,
  noWhenBranchMatchedException2a6r7ubxgky5j as noWhenBranchMatchedException,
  toLongOrNullutqivezb0wx1 as toLongOrNull,
  toULongOrNullojoyxi0i9tgj as toULongOrNull,
  ULong3f9k7s38t3rfp as ULong,
  Companion_getInstance2r8lbbjwejmb0 as Companion_getInstance,
  _ULong___get_data__impl__fggpzb77rs34yu2akv as _ULong___get_data__impl__fggpzb,
  toDoubleOrNullkxwozihadygj as toDoubleOrNull,
  toBooleanStrictOrNull2j0md398tkvbj as toBooleanStrictOrNull,
  IllegalStateExceptionkoljg5n0nrlr as IllegalStateException,
  lazy2hsh8ze7j6ikd as lazy_0,
  protoOf180f3jzyo7rfj as protoOf,
  KProperty1ca4yb4wlo496 as KProperty1,
  getPropertyCallableRef1ajb9in178r5r as getPropertyCallableRef,
  toLongw1zpgk99d84b as toLong,
  _UInt___init__impl__l7qpdl2x2ja0qtrydmg as _UInt___init__impl__l7qpdl,
  UInt__toString_impl_dbgl21zkdo3skdvztx as UInt__toString_impl_dbgl21,
  _ULong___init__impl__c78o9k1neui78jb9mlg as _ULong___init__impl__c78o9k,
  ULong__toString_impl_f9au7k260qy52yi92xo as ULong__toString_impl_f9au7k,
  _UByte___init__impl__g9hnc43i8t7wecfr79w as _UByte___init__impl__g9hnc4,
  UByte__toString_impl_v72jg3ruswpcjtpyk as UByte__toString_impl_v72jg,
  _UShort___init__impl__jigrne18f2wrm3i4dpy as _UShort___init__impl__jigrne,
  UShort__toString_impl_edaoee32kikxrf4p0yn as UShort__toString_impl_edaoee,
  captureStack1fzi4aczwc4hg as captureStack,
  charSequenceSubSequence1iwpdba8s3jc7 as charSequenceSubSequence,
  coerceAtLeast2bkz8m9ik7hep as coerceAtLeast,
  coerceAtMost322komnqp70ag as coerceAtMost,
  LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap,
  ArrayList3it5z8td81qkl as ArrayList,
  singleOrNullrknfaxokm1sl as singleOrNull,
  emptyMapr06gerzljqtm as emptyMap,
  getValue48kllevslyh6 as getValue,
  fillArrayVali8eppxapiek4 as fillArrayVal,
  copyOf2ng0t8oizk6it as copyOf,
  copyOf3rutauicler23 as copyOf_0,
  get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED,
  suspendOrReturn49pspzlx5djv as suspendOrReturn,
  DeepRecursiveFunction3r49v8igsve1g as DeepRecursiveFunction,
  invoke246lvi6tzooz1 as invoke,
  DeepRecursiveScope1pqaydvh4vdcu as DeepRecursiveScope,
  Unitkvevlwgzwiuc as Unit,
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
  getKClass1s3j9wy1cofik as getKClass,
  ensureNotNull1e947j3ixpazm as ensureNotNull,
  substringBefore3n7kj60w69hju as substringBefore,
  removeSuffix3d61x5lsuvuho as removeSuffix,
  substringAfter1hku067gwr5ve as substringAfter,
  contains3ue2qo8xhmpf1 as contains_0,
  plus17rl43at52ays as plus,
  isFinite1tx0gn65nl9tj as isFinite,
  isFinite2t9l5a275mxm6 as isFinite_0,
  toUInt21lx0mz8wkp7c as toUInt,
  _UInt___get_data__impl__f0vqqw1wfqgh301wggv as _UInt___get_data__impl__f0vqqw,
  toULong266mnyksbttkw as toULong,
  toUByteh6p4wmqswkrs as toUByte,
  _UByte___get_data__impl__jof9qr1jhbnu489etgz as _UByte___get_data__impl__jof9qr,
  toUShort7yqspfnhrot4 as toUShort,
  _UShort___get_data__impl__g02453buibbzrpmeid as _UShort___get_data__impl__g0245,
  toString14fd7g605f91p as toString_1,
  Companion_getInstance316n37o3eume as Companion_getInstance_0,
  Companion_getInstance16xypb6k4bny3 as Companion_getInstance_1,
  Companion_getInstance3956vha054dts as Companion_getInstance_2,
  setOf45ia9pnfhe90 as setOf,
  Char__toInt_impl_vasixd17daqndsyg0ov as Char__toInt_impl_vasixd,
  numberToChar93r9buh19yek as numberToChar,
  equals2v6cggk171b6e as equals_0,
  startsWith26w8qjqapeeq6 as startsWith,
  toByte4i43936u611k as toByte,
  toShort36kaw0zjdq3ex as toShort,
  single29ec4rh52687r as single,
  Char19o2r8palgjof as Char,
  emptySetcxexqki71qfa as emptySet,
  plus1ogy4liedzq5j as plus_0,
  toInt2q8uldh7sc951 as toInt,
  toList3jhuyej2anx2q as toList,
  enumEntries20mr21zbe3az4 as enumEntries,
  last1vo29oleiqj36 as last,
  removeLast3759euu1xvfa3 as removeLast,
  lastIndexOf2d52xhix5ymjr as lastIndexOf,
  Long2qws0ah9gnpki as Long,
  Char__minus_impl_a2frrh15zl6plytfjgc as Char__minus_impl_a2frrh,
  numberToLong1a4cndvg6c52s as numberToLong,
  charArray2ujmm1qusno00 as charArray,
  indexOfwa4w6635jewi as indexOf,
  indexOf1xbs558u7wr52 as indexOf_0,
  HashMap1a0ld5kgwhmhv as HashMap,
} from './kotlin-kotlin-stdlib.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
class Json {
  constructor(configuration, serializersModule) {
    Default_getInstance();
    this.ecx_1 = configuration;
    this.fcx_1 = serializersModule;
    this.gcx_1 = new DescriptorSchemaCache();
  }
  ucg() {
    return this.fcx_1;
  }
  hcx(serializer, value) {
    var result = new JsonToStringWriter();
    try {
      encodeByWriter(this, result, serializer, value);
      return result.toString();
    }finally {
      result.n1p();
    }
  }
  icx(deserializer, string) {
    var lexer = StringJsonLexer_0(this, string);
    var input = new StreamingJsonDecoder(this, WriteMode_OBJ_getInstance(), lexer, deserializer.jcc(), null);
    var result = input.ecg(deserializer);
    lexer.wcx();
    return result;
  }
}
class Default extends Json {
  constructor() {
    Default_instance = null;
    super(new JsonConfiguration(), EmptySerializersModule());
    Default_instance = this;
  }
}
class JsonBuilder {
  constructor(json) {
    this.xcx_1 = json.ecx_1.qcy_1;
    this.ycx_1 = json.ecx_1.vcy_1;
    this.zcx_1 = json.ecx_1.rcy_1;
    this.acy_1 = json.ecx_1.scy_1;
    this.bcy_1 = json.ecx_1.ucy_1;
    this.ccy_1 = json.ecx_1.wcy_1;
    this.dcy_1 = json.ecx_1.xcy_1;
    this.ecy_1 = json.ecx_1.zcy_1;
    this.fcy_1 = json.ecx_1.gcz_1;
    this.gcy_1 = json.ecx_1.bcz_1;
    this.hcy_1 = json.ecx_1.ccz_1;
    this.icy_1 = json.ecx_1.dcz_1;
    this.jcy_1 = json.ecx_1.ecz_1;
    this.kcy_1 = json.ecx_1.fcz_1;
    this.lcy_1 = json.ecx_1.acz_1;
    this.mcy_1 = json.ecx_1.tcy_1;
    this.ncy_1 = json.ecx_1.ycy_1;
    this.ocy_1 = json.ucg();
  }
  pcy() {
    if (this.ncy_1) {
      // Inline function 'kotlin.require' call
      // Inline function 'kotlin.contracts.contract' call
      if (!(this.ecy_1 === 'type')) {
        // Inline function 'kotlinx.serialization.json.JsonBuilder.build.<anonymous>' call
        var message = 'Class discriminator should not be specified when array polymorphism is specified';
        throw IllegalArgumentException.l(toString(message));
      }
      // Inline function 'kotlin.require' call
      // Inline function 'kotlin.contracts.contract' call
      if (!this.fcy_1.equals(ClassDiscriminatorMode_POLYMORPHIC_getInstance())) {
        // Inline function 'kotlinx.serialization.json.JsonBuilder.build.<anonymous>' call
        var message_0 = 'useArrayPolymorphism option can only be used if classDiscriminatorMode in a default POLYMORPHIC state.';
        throw IllegalArgumentException.l(toString(message_0));
      }
    }
    if (!this.bcy_1) {
      // Inline function 'kotlin.require' call
      // Inline function 'kotlin.contracts.contract' call
      if (!(this.ccy_1 === '    ')) {
        // Inline function 'kotlinx.serialization.json.JsonBuilder.build.<anonymous>' call
        var message_1 = 'Indent should not be specified when default printing mode is used';
        throw IllegalArgumentException.l(toString(message_1));
      }
    } else if (!(this.ccy_1 === '    ')) {
      var tmp$ret$4;
      $l$block: {
        // Inline function 'kotlin.text.all' call
        var indexedObject = this.ccy_1;
        var inductionVariable = 0;
        while (inductionVariable < charSequenceLength(indexedObject)) {
          var element = charSequenceGet(indexedObject, inductionVariable);
          inductionVariable = inductionVariable + 1 | 0;
          // Inline function 'kotlinx.serialization.json.JsonBuilder.build.<anonymous>' call
          if (!(element === _Char___init__impl__6a9atx(32) || element === _Char___init__impl__6a9atx(9) || element === _Char___init__impl__6a9atx(13) || element === _Char___init__impl__6a9atx(10))) {
            tmp$ret$4 = false;
            break $l$block;
          }
        }
        tmp$ret$4 = true;
      }
      var allWhitespaces = tmp$ret$4;
      // Inline function 'kotlin.require' call
      // Inline function 'kotlin.contracts.contract' call
      if (!allWhitespaces) {
        // Inline function 'kotlinx.serialization.json.JsonBuilder.build.<anonymous>' call
        var message_2 = 'Only whitespace, tab, newline and carriage return are allowed as pretty print symbols. Had ' + this.ccy_1;
        throw IllegalArgumentException.l(toString(message_2));
      }
    }
    return new JsonConfiguration(this.xcx_1, this.zcx_1, this.acy_1, this.mcy_1, this.bcy_1, this.ycx_1, this.ccy_1, this.dcy_1, this.ncy_1, this.ecy_1, this.lcy_1, this.gcy_1, this.hcy_1, this.icy_1, this.jcy_1, this.kcy_1, this.fcy_1);
  }
}
class JsonImpl extends Json {
  constructor(configuration, module_0) {
    super(configuration, module_0);
    validateConfiguration(this);
  }
}
class JsonClassDiscriminator {}
class JsonNames {}
class JsonConfiguration {
  constructor(encodeDefaults, ignoreUnknownKeys, isLenient, allowStructuredMapKeys, prettyPrint, explicitNulls, prettyPrintIndent, coerceInputValues, useArrayPolymorphism, classDiscriminator, allowSpecialFloatingPointValues, useAlternativeNames, namingStrategy, decodeEnumsCaseInsensitive, allowTrailingComma, allowComments, classDiscriminatorMode) {
    encodeDefaults = encodeDefaults === VOID ? false : encodeDefaults;
    ignoreUnknownKeys = ignoreUnknownKeys === VOID ? false : ignoreUnknownKeys;
    isLenient = isLenient === VOID ? false : isLenient;
    allowStructuredMapKeys = allowStructuredMapKeys === VOID ? false : allowStructuredMapKeys;
    prettyPrint = prettyPrint === VOID ? false : prettyPrint;
    explicitNulls = explicitNulls === VOID ? true : explicitNulls;
    prettyPrintIndent = prettyPrintIndent === VOID ? '    ' : prettyPrintIndent;
    coerceInputValues = coerceInputValues === VOID ? false : coerceInputValues;
    useArrayPolymorphism = useArrayPolymorphism === VOID ? false : useArrayPolymorphism;
    classDiscriminator = classDiscriminator === VOID ? 'type' : classDiscriminator;
    allowSpecialFloatingPointValues = allowSpecialFloatingPointValues === VOID ? false : allowSpecialFloatingPointValues;
    useAlternativeNames = useAlternativeNames === VOID ? true : useAlternativeNames;
    namingStrategy = namingStrategy === VOID ? null : namingStrategy;
    decodeEnumsCaseInsensitive = decodeEnumsCaseInsensitive === VOID ? false : decodeEnumsCaseInsensitive;
    allowTrailingComma = allowTrailingComma === VOID ? false : allowTrailingComma;
    allowComments = allowComments === VOID ? false : allowComments;
    classDiscriminatorMode = classDiscriminatorMode === VOID ? ClassDiscriminatorMode_POLYMORPHIC_getInstance() : classDiscriminatorMode;
    this.qcy_1 = encodeDefaults;
    this.rcy_1 = ignoreUnknownKeys;
    this.scy_1 = isLenient;
    this.tcy_1 = allowStructuredMapKeys;
    this.ucy_1 = prettyPrint;
    this.vcy_1 = explicitNulls;
    this.wcy_1 = prettyPrintIndent;
    this.xcy_1 = coerceInputValues;
    this.ycy_1 = useArrayPolymorphism;
    this.zcy_1 = classDiscriminator;
    this.acz_1 = allowSpecialFloatingPointValues;
    this.bcz_1 = useAlternativeNames;
    this.ccz_1 = namingStrategy;
    this.dcz_1 = decodeEnumsCaseInsensitive;
    this.ecz_1 = allowTrailingComma;
    this.fcz_1 = allowComments;
    this.gcz_1 = classDiscriminatorMode;
  }
  toString() {
    return 'JsonConfiguration(encodeDefaults=' + this.qcy_1 + ', ignoreUnknownKeys=' + this.rcy_1 + ', isLenient=' + this.scy_1 + ', ' + ('allowStructuredMapKeys=' + this.tcy_1 + ', prettyPrint=' + this.ucy_1 + ', explicitNulls=' + this.vcy_1 + ', ') + ("prettyPrintIndent='" + this.wcy_1 + "', coerceInputValues=" + this.xcy_1 + ', useArrayPolymorphism=' + this.ycy_1 + ', ') + ("classDiscriminator='" + this.zcy_1 + "', allowSpecialFloatingPointValues=" + this.acz_1 + ', ') + ('useAlternativeNames=' + this.bcz_1 + ', namingStrategy=' + toString_0(this.ccz_1) + ', decodeEnumsCaseInsensitive=' + this.dcz_1 + ', ') + ('allowTrailingComma=' + this.ecz_1 + ', allowComments=' + this.fcz_1 + ', classDiscriminatorMode=' + this.gcz_1.toString() + ')');
  }
}
class ClassDiscriminatorMode extends Enum {}
class JsonDecoder {}
class Companion {}
class JsonElement {}
class Companion_0 {}
class JsonObject extends JsonElement {
  constructor(content) {
    super();
    this.jcz_1 = content;
  }
  f11(key) {
    return this.jcz_1.f3(key);
  }
  f3(key) {
    if (!(!(key == null) ? typeof key === 'string' : false))
      return false;
    return this.f11((!(key == null) ? typeof key === 'string' : false) ? key : THROW_CCE());
  }
  oi(key) {
    return this.jcz_1.h3(key);
  }
  h3(key) {
    if (!(!(key == null) ? typeof key === 'string' : false))
      return null;
    return this.oi((!(key == null) ? typeof key === 'string' : false) ? key : THROW_CCE());
  }
  g1() {
    return this.jcz_1.g1();
  }
  s1() {
    return this.jcz_1.s1();
  }
  i3() {
    return this.jcz_1.i3();
  }
  e1() {
    return this.jcz_1.e1();
  }
  equals(other) {
    return equals(this.jcz_1, other);
  }
  hashCode() {
    return hashCode(this.jcz_1);
  }
  toString() {
    var tmp = this.jcz_1.s1();
    return joinToString(tmp, ',', '{', '}', VOID, VOID, JsonObject$toString$lambda);
  }
}
class JsonPrimitive extends JsonElement {
  toString() {
    return this.e41();
  }
}
class JsonNull extends JsonPrimitive {
  constructor() {
    JsonNull_instance = null;
    super();
    JsonNull_instance = this;
    this.kcz_1 = 'null';
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.lcz_1 = lazy(tmp_0, JsonNull$_anonymous__enib48);
  }
  e41() {
    return this.kcz_1;
  }
  mcz() {
    return _get_$cachedSerializer__te6jhj(this);
  }
  tco(typeParamsSerializers) {
    return this.mcz();
  }
}
class Companion_1 {}
class JsonLiteral extends JsonPrimitive {
  constructor(body, isString, coerceToInlineType) {
    coerceToInlineType = coerceToInlineType === VOID ? null : coerceToInlineType;
    super();
    this.ncz_1 = isString;
    this.ocz_1 = coerceToInlineType;
    this.pcz_1 = toString(body);
    if (!(this.ocz_1 == null)) {
      // Inline function 'kotlin.require' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'kotlin.require' call
      // Inline function 'kotlin.contracts.contract' call
      if (!this.ocz_1.pce()) {
        // Inline function 'kotlin.require.<anonymous>' call
        var message = 'Failed requirement.';
        throw IllegalArgumentException.l(toString(message));
      }
    }
  }
  e41() {
    return this.pcz_1;
  }
  toString() {
    var tmp;
    if (this.ncz_1) {
      // Inline function 'kotlin.text.buildString' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'kotlin.apply' call
      var this_0 = StringBuilder.f();
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'kotlinx.serialization.json.JsonLiteral.toString.<anonymous>' call
      printQuoted(this_0, this.pcz_1);
      tmp = this_0.toString();
    } else {
      tmp = this.pcz_1;
    }
    return tmp;
  }
  equals(other) {
    if (this === other)
      return true;
    if (other == null || !getKClassFromExpression(this).equals(getKClassFromExpression(other)))
      return false;
    if (!(other instanceof JsonLiteral))
      THROW_CCE();
    if (!(this.ncz_1 === other.ncz_1))
      return false;
    if (!(this.pcz_1 === other.pcz_1))
      return false;
    return true;
  }
  hashCode() {
    var result = getBooleanHashCode(this.ncz_1);
    result = imul(31, result) + getStringHashCode(this.pcz_1) | 0;
    return result;
  }
}
class Companion_2 {}
class JsonArray extends JsonElement {
  constructor(content) {
    super();
    this.qcz_1 = content;
  }
  rcz(elements) {
    return this.qcz_1.a3(elements);
  }
  a3(elements) {
    return this.rcz(elements);
  }
  d1(index) {
    return this.qcz_1.d1(index);
  }
  scz(element) {
    return this.qcz_1.b3(element);
  }
  b3(element) {
    if (!(element instanceof JsonElement))
      return -1;
    return this.scz(element instanceof JsonElement ? element : THROW_CCE());
  }
  g1() {
    return this.qcz_1.g1();
  }
  a1() {
    return this.qcz_1.a1();
  }
  c3() {
    return this.qcz_1.c3();
  }
  d3(index) {
    return this.qcz_1.d3(index);
  }
  e3(fromIndex, toIndex) {
    return this.qcz_1.e3(fromIndex, toIndex);
  }
  e1() {
    return this.qcz_1.e1();
  }
  equals(other) {
    return equals(this.qcz_1, other);
  }
  hashCode() {
    return hashCode(this.qcz_1);
  }
  toString() {
    return joinToString(this.qcz_1, ',', '[', ']');
  }
}
class JsonElementSerializer {
  constructor() {
    JsonElementSerializer_instance = this;
    var tmp = this;
    var tmp_0 = SEALED_getInstance();
    tmp.zcz_1 = buildSerialDescriptor('kotlinx.serialization.json.JsonElement', tmp_0, [], JsonElementSerializer$descriptor$lambda);
  }
  jcc() {
    return this.zcz_1;
  }
  ad0(encoder, value) {
    verify(encoder);
    if (value instanceof JsonPrimitive) {
      encoder.ych(JsonPrimitiveSerializer_getInstance(), value);
    } else {
      if (value instanceof JsonObject) {
        encoder.ych(JsonObjectSerializer_getInstance(), value);
      } else {
        if (value instanceof JsonArray) {
          encoder.ych(JsonArraySerializer_getInstance(), value);
        } else {
          noWhenBranchMatchedException();
        }
      }
    }
  }
  kcc(encoder, value) {
    return this.ad0(encoder, value instanceof JsonElement ? value : THROW_CCE());
  }
  lcc(decoder) {
    var input = asJsonDecoder(decoder);
    return input.icz();
  }
}
class JsonObjectDescriptor {
  constructor() {
    JsonObjectDescriptor_instance = this;
    this.bd0_1 = MapSerializer(serializer(StringCompanionObject_instance), JsonElementSerializer_getInstance()).jcc();
    this.cd0_1 = 'kotlinx.serialization.json.JsonObject';
  }
  jce(index) {
    return this.bd0_1.jce(index);
  }
  kce(name) {
    return this.bd0_1.kce(name);
  }
  lce(index) {
    return this.bd0_1.lce(index);
  }
  mce(index) {
    return this.bd0_1.mce(index);
  }
  nce(index) {
    return this.bd0_1.nce(index);
  }
  oce() {
    return this.bd0_1.oce();
  }
  ece() {
    return this.bd0_1.ece();
  }
  pce() {
    return this.bd0_1.pce();
  }
  qce() {
    return this.bd0_1.qce();
  }
  rce() {
    return this.bd0_1.rce();
  }
  ice() {
    return this.cd0_1;
  }
}
class JsonObjectSerializer {
  constructor() {
    JsonObjectSerializer_instance = this;
    this.xcz_1 = JsonObjectDescriptor_getInstance();
  }
  jcc() {
    return this.xcz_1;
  }
  dd0(encoder, value) {
    verify(encoder);
    MapSerializer(serializer(StringCompanionObject_instance), JsonElementSerializer_getInstance()).kcc(encoder, value);
  }
  kcc(encoder, value) {
    return this.dd0(encoder, value instanceof JsonObject ? value : THROW_CCE());
  }
  lcc(decoder) {
    verify_0(decoder);
    return new JsonObject(MapSerializer(serializer(StringCompanionObject_instance), JsonElementSerializer_getInstance()).lcc(decoder));
  }
}
class JsonArrayDescriptor {
  constructor() {
    JsonArrayDescriptor_instance = this;
    this.ed0_1 = ListSerializer(JsonElementSerializer_getInstance()).jcc();
    this.fd0_1 = 'kotlinx.serialization.json.JsonArray';
  }
  jce(index) {
    return this.ed0_1.jce(index);
  }
  kce(name) {
    return this.ed0_1.kce(name);
  }
  lce(index) {
    return this.ed0_1.lce(index);
  }
  mce(index) {
    return this.ed0_1.mce(index);
  }
  nce(index) {
    return this.ed0_1.nce(index);
  }
  oce() {
    return this.ed0_1.oce();
  }
  ece() {
    return this.ed0_1.ece();
  }
  pce() {
    return this.ed0_1.pce();
  }
  qce() {
    return this.ed0_1.qce();
  }
  rce() {
    return this.ed0_1.rce();
  }
  ice() {
    return this.fd0_1;
  }
}
class JsonArraySerializer {
  constructor() {
    JsonArraySerializer_instance = this;
    this.ycz_1 = JsonArrayDescriptor_getInstance();
  }
  jcc() {
    return this.ycz_1;
  }
  gd0(encoder, value) {
    verify(encoder);
    ListSerializer(JsonElementSerializer_getInstance()).kcc(encoder, value);
  }
  kcc(encoder, value) {
    return this.gd0(encoder, value instanceof JsonArray ? value : THROW_CCE());
  }
  lcc(decoder) {
    verify_0(decoder);
    return new JsonArray(ListSerializer(JsonElementSerializer_getInstance()).lcc(decoder));
  }
}
class JsonPrimitiveSerializer {
  constructor() {
    JsonPrimitiveSerializer_instance = this;
    this.ucz_1 = buildSerialDescriptor('kotlinx.serialization.json.JsonPrimitive', STRING_getInstance(), []);
  }
  jcc() {
    return this.ucz_1;
  }
  hd0(encoder, value) {
    verify(encoder);
    var tmp;
    if (value instanceof JsonNull) {
      encoder.ych(JsonNullSerializer_getInstance(), JsonNull_getInstance());
      tmp = Unit_instance;
    } else {
      var tmp_0 = JsonLiteralSerializer_getInstance();
      encoder.ych(tmp_0, value instanceof JsonLiteral ? value : THROW_CCE());
      tmp = Unit_instance;
    }
    return tmp;
  }
  kcc(encoder, value) {
    return this.hd0(encoder, value instanceof JsonPrimitive ? value : THROW_CCE());
  }
  lcc(decoder) {
    var result = asJsonDecoder(decoder).icz();
    if (!(result instanceof JsonPrimitive))
      throw JsonDecodingException_0(-1, 'Unexpected JSON element, expected JsonPrimitive, had ' + toString(getKClassFromExpression(result)), toString(result));
    return result;
  }
}
class JsonNullSerializer {
  constructor() {
    JsonNullSerializer_instance = this;
    this.vcz_1 = buildSerialDescriptor('kotlinx.serialization.json.JsonNull', ENUM_getInstance(), []);
  }
  jcc() {
    return this.vcz_1;
  }
  id0(encoder, value) {
    verify(encoder);
    encoder.bch();
  }
  kcc(encoder, value) {
    return this.id0(encoder, value instanceof JsonNull ? value : THROW_CCE());
  }
  lcc(decoder) {
    verify_0(decoder);
    if (decoder.qcf()) {
      throw JsonDecodingException.pd0("Expected 'null' literal");
    }
    decoder.rcf();
    return JsonNull_getInstance();
  }
}
class JsonLiteralSerializer {
  constructor() {
    JsonLiteralSerializer_instance = this;
    this.wcz_1 = PrimitiveSerialDescriptor('kotlinx.serialization.json.JsonLiteral', STRING_getInstance());
  }
  jcc() {
    return this.wcz_1;
  }
  qd0(encoder, value) {
    verify(encoder);
    if (value.ncz_1) {
      return encoder.kch(value.pcz_1);
    }
    if (!(value.ocz_1 == null)) {
      return encoder.mch(value.ocz_1).kch(value.pcz_1);
    }
    var tmp2_safe_receiver = toLongOrNull(value.pcz_1);
    if (tmp2_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      return encoder.gch(tmp2_safe_receiver);
    }
    var tmp3_safe_receiver = toULongOrNull(value.pcz_1);
    var tmp = tmp3_safe_receiver;
    if ((tmp == null ? null : new ULong(tmp)) == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      var tmp_0 = tmp3_safe_receiver;
      // Inline function 'kotlin.contracts.contract' call
      var it = (tmp_0 == null ? null : new ULong(tmp_0)).cu_1;
      var tmp_1 = encoder.mch(serializer_0(Companion_getInstance()).jcc());
      // Inline function 'kotlin.ULong.toLong' call
      var tmp$ret$1 = _ULong___get_data__impl__fggpzb(it);
      tmp_1.gch(tmp$ret$1);
      return Unit_instance;
    }
    var tmp4_safe_receiver = toDoubleOrNull(value.pcz_1);
    if (tmp4_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      return encoder.ich(tmp4_safe_receiver);
    }
    var tmp5_safe_receiver = toBooleanStrictOrNull(value.pcz_1);
    if (tmp5_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      return encoder.cch(tmp5_safe_receiver);
    }
    encoder.kch(value.pcz_1);
  }
  kcc(encoder, value) {
    return this.qd0(encoder, value instanceof JsonLiteral ? value : THROW_CCE());
  }
  lcc(decoder) {
    var result = asJsonDecoder(decoder).icz();
    if (!(result instanceof JsonLiteral))
      throw JsonDecodingException_0(-1, 'Unexpected JSON element, expected JsonLiteral, had ' + toString(getKClassFromExpression(result)), toString(result));
    return result;
  }
}
class defer$1 {
  constructor($deferred) {
    this.rd0_1 = lazy_0($deferred);
  }
  ice() {
    return _get_original__l7ku1m(this).ice();
  }
  oce() {
    return _get_original__l7ku1m(this).oce();
  }
  qce() {
    return _get_original__l7ku1m(this).qce();
  }
  jce(index) {
    return _get_original__l7ku1m(this).jce(index);
  }
  kce(name) {
    return _get_original__l7ku1m(this).kce(name);
  }
  lce(index) {
    return _get_original__l7ku1m(this).lce(index);
  }
  mce(index) {
    return _get_original__l7ku1m(this).mce(index);
  }
  nce(index) {
    return _get_original__l7ku1m(this).nce(index);
  }
}
class JsonEncoder {}
class Composer {
  constructor(writer) {
    this.sd0_1 = writer;
    this.td0_1 = true;
  }
  z3c() {
    this.td0_1 = true;
  }
  ud0() {
    return Unit_instance;
  }
  vd0() {
    this.td0_1 = false;
  }
  wd0() {
    this.td0_1 = false;
  }
  xd0() {
    return Unit_instance;
  }
  yd0(v) {
    return this.sd0_1.zd0(v);
  }
  ad1(v) {
    return this.sd0_1.bd1(v);
  }
  cd1(v) {
    return this.sd0_1.bd1(v.toString());
  }
  dd1(v) {
    return this.sd0_1.bd1(v.toString());
  }
  ed1(v) {
    return this.sd0_1.fd1(toLong(v));
  }
  gd1(v) {
    return this.sd0_1.fd1(toLong(v));
  }
  hd1(v) {
    return this.sd0_1.fd1(toLong(v));
  }
  id1(v) {
    return this.sd0_1.fd1(v);
  }
  jd1(v) {
    return this.sd0_1.bd1(v.toString());
  }
  kd1(value) {
    return this.sd0_1.ld1(value);
  }
}
class ComposerForUnsignedNumbers extends Composer {
  constructor(writer, forceQuoting) {
    super(writer);
    this.od1_1 = forceQuoting;
  }
  hd1(v) {
    if (this.od1_1) {
      // Inline function 'kotlin.toUInt' call
      var tmp$ret$0 = _UInt___init__impl__l7qpdl(v);
      this.kd1(UInt__toString_impl_dbgl21(tmp$ret$0));
    } else {
      // Inline function 'kotlin.toUInt' call
      var tmp$ret$1 = _UInt___init__impl__l7qpdl(v);
      this.ad1(UInt__toString_impl_dbgl21(tmp$ret$1));
    }
  }
  id1(v) {
    if (this.od1_1) {
      // Inline function 'kotlin.toULong' call
      var tmp$ret$0 = _ULong___init__impl__c78o9k(v);
      this.kd1(ULong__toString_impl_f9au7k(tmp$ret$0));
    } else {
      // Inline function 'kotlin.toULong' call
      var tmp$ret$1 = _ULong___init__impl__c78o9k(v);
      this.ad1(ULong__toString_impl_f9au7k(tmp$ret$1));
    }
  }
  ed1(v) {
    if (this.od1_1) {
      // Inline function 'kotlin.toUByte' call
      var tmp$ret$0 = _UByte___init__impl__g9hnc4(v);
      this.kd1(UByte__toString_impl_v72jg(tmp$ret$0));
    } else {
      // Inline function 'kotlin.toUByte' call
      var tmp$ret$1 = _UByte___init__impl__g9hnc4(v);
      this.ad1(UByte__toString_impl_v72jg(tmp$ret$1));
    }
  }
  gd1(v) {
    if (this.od1_1) {
      // Inline function 'kotlin.toUShort' call
      var tmp$ret$0 = _UShort___init__impl__jigrne(v);
      this.kd1(UShort__toString_impl_edaoee(tmp$ret$0));
    } else {
      // Inline function 'kotlin.toUShort' call
      var tmp$ret$1 = _UShort___init__impl__jigrne(v);
      this.ad1(UShort__toString_impl_edaoee(tmp$ret$1));
    }
  }
}
class ComposerForUnquotedLiterals extends Composer {
  constructor(writer, forceQuoting) {
    super(writer);
    this.rd1_1 = forceQuoting;
  }
  kd1(value) {
    if (this.rd1_1) {
      super.kd1(value);
    } else {
      super.ad1(value);
    }
  }
}
class ComposerWithPrettyPrint extends Composer {
  constructor(writer, json) {
    super(writer);
    this.ud1_1 = json;
    this.vd1_1 = 0;
  }
  z3c() {
    this.td0_1 = true;
    this.vd1_1 = this.vd1_1 + 1 | 0;
  }
  ud0() {
    this.vd1_1 = this.vd1_1 - 1 | 0;
  }
  vd0() {
    this.td0_1 = false;
    this.ad1('\n');
    // Inline function 'kotlin.repeat' call
    var times = this.vd1_1;
    // Inline function 'kotlin.contracts.contract' call
    var inductionVariable = 0;
    if (inductionVariable < times)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'kotlinx.serialization.json.internal.ComposerWithPrettyPrint.nextItem.<anonymous>' call
        this.ad1(this.ud1_1.ecx_1.wcy_1);
      }
       while (inductionVariable < times);
  }
  wd0() {
    if (this.td0_1)
      this.td0_1 = false;
    else {
      this.vd0();
    }
  }
  xd0() {
    this.yd0(_Char___init__impl__6a9atx(32));
  }
}
class JsonElementMarker {
  constructor(descriptor) {
    var tmp = this;
    tmp.wd1_1 = new ElementMarker(descriptor, JsonElementMarker$readIfAbsent$ref(this));
    this.xd1_1 = false;
  }
  yd1(index) {
    this.wd1_1.kcm(index);
  }
  zd1() {
    return this.wd1_1.lcm();
  }
}
class JsonException extends SerializationException {
  static od2(message) {
    var $this = this.icd(message);
    captureStack($this, $this.nd2_1);
    return $this;
  }
}
class JsonEncodingException extends JsonException {
  static id2(message) {
    var $this = this.od2(message);
    captureStack($this, $this.hd2_1);
    return $this;
  }
}
class JsonDecodingException extends JsonException {
  static pd0(message) {
    var $this = this.od2(message);
    captureStack($this, $this.od0_1);
    return $this;
  }
}
class Tombstone {}
class JsonPath {
  constructor() {
    var tmp = this;
    // Inline function 'kotlin.arrayOfNulls' call
    tmp.td2_1 = fillArrayVal(Array(8), null);
    var tmp_0 = this;
    var tmp_1 = 0;
    var tmp_2 = new Int32Array(8);
    while (tmp_1 < 8) {
      tmp_2[tmp_1] = -1;
      tmp_1 = tmp_1 + 1 | 0;
    }
    tmp_0.ud2_1 = tmp_2;
    this.vd2_1 = -1;
  }
  wd2(sd) {
    this.vd2_1 = this.vd2_1 + 1 | 0;
    var depth = this.vd2_1;
    if (depth === this.td2_1.length) {
      resize(this);
    }
    this.td2_1[depth] = sd;
  }
  xd2(index) {
    this.ud2_1[this.vd2_1] = index;
  }
  yd2(key) {
    var tmp;
    if (!(this.ud2_1[this.vd2_1] === -2)) {
      this.vd2_1 = this.vd2_1 + 1 | 0;
      tmp = this.vd2_1 === this.td2_1.length;
    } else {
      tmp = false;
    }
    if (tmp) {
      resize(this);
    }
    this.td2_1[this.vd2_1] = key;
    this.ud2_1[this.vd2_1] = -2;
  }
  zd2() {
    if (this.ud2_1[this.vd2_1] === -2) {
      this.td2_1[this.vd2_1] = Tombstone_instance;
    }
  }
  ad3() {
    var depth = this.vd2_1;
    if (this.ud2_1[depth] === -2) {
      this.ud2_1[depth] = -1;
      this.vd2_1 = this.vd2_1 - 1 | 0;
    }
    if (!(this.vd2_1 === -1)) {
      this.vd2_1 = this.vd2_1 - 1 | 0;
    }
  }
  bd3() {
    // Inline function 'kotlin.text.buildString' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.apply' call
    var this_0 = StringBuilder.f();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlinx.serialization.json.internal.JsonPath.getPath.<anonymous>' call
    this_0.ec('$');
    // Inline function 'kotlin.repeat' call
    var times = this.vd2_1 + 1 | 0;
    // Inline function 'kotlin.contracts.contract' call
    var inductionVariable = 0;
    if (inductionVariable < times)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'kotlinx.serialization.json.internal.JsonPath.getPath.<anonymous>.<anonymous>' call
        var element = this.td2_1[index];
        if (!(element == null) ? isInterface(element, SerialDescriptor) : false) {
          if (equals(element.oce(), LIST_getInstance())) {
            if (!(this.ud2_1[index] === -1)) {
              this_0.ec('[');
              this_0.gh(this.ud2_1[index]);
              this_0.ec(']');
            }
          } else {
            var idx = this.ud2_1[index];
            if (idx >= 0) {
              this_0.ec('.');
              this_0.ec(element.jce(idx));
            }
          }
        } else {
          if (!(element === Tombstone_instance)) {
            this_0.ec('[');
            this_0.ec("'");
            this_0.dc(element);
            this_0.ec("'");
            this_0.ec(']');
          }
        }
      }
       while (inductionVariable < times);
    return this_0.toString();
  }
  toString() {
    return this.bd3();
  }
}
class JsonTreeReader$readDeepRecursive$slambda {
  constructor(this$0) {
    this.qd3_1 = this$0;
  }
  xd3($this$DeepRecursiveFunction, it, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8.bind(VOID, this, $this$DeepRecursiveFunction, it), $completion);
  }
  he(p1, p2, $completion) {
    var tmp = p1 instanceof DeepRecursiveScope ? p1 : THROW_CCE();
    return this.xd3(tmp, p2 instanceof Unit ? p2 : THROW_CCE(), $completion);
  }
}
class JsonTreeReader {
  constructor(configuration, lexer) {
    this.md3_1 = lexer;
    this.nd3_1 = configuration.scy_1;
    this.od3_1 = configuration.ecz_1;
    this.pd3_1 = 0;
  }
  w1x() {
    var token = this.md3_1.rd3();
    var tmp;
    if (token === 1) {
      tmp = readValue(this, true);
    } else if (token === 0) {
      tmp = readValue(this, false);
    } else if (token === 6) {
      var tmp_0;
      this.pd3_1 = this.pd3_1 + 1 | 0;
      if (this.pd3_1 === 200) {
        tmp_0 = readDeepRecursive(this);
      } else {
        tmp_0 = readObject(this);
      }
      var result = tmp_0;
      this.pd3_1 = this.pd3_1 - 1 | 0;
      tmp = result;
    } else if (token === 8) {
      tmp = readArray(this);
    } else {
      this.md3_1.bd2('Cannot read Json element because of unexpected ' + tokenDescription(token));
    }
    return tmp;
  }
}
class PolymorphismValidator {
  constructor(useArrayPolymorphism, discriminator) {
    this.zd3_1 = useArrayPolymorphism;
    this.ad4_1 = discriminator;
  }
  vcw(kClass, provider) {
  }
  ycw(baseClass, actualClass, actualSerializer) {
    var descriptor = actualSerializer.jcc();
    checkKind_0(this, descriptor, actualClass);
    if (!this.zd3_1) {
      checkDiscriminatorCollisions(this, descriptor, actualClass);
    }
  }
  zcw(baseClass, defaultSerializerProvider) {
  }
  acx(baseClass, defaultDeserializerProvider) {
  }
}
class Key {}
class DescriptorSchemaCache {
  constructor() {
    this.pd2_1 = createMapForCache(16);
  }
  bd4(descriptor, key, value) {
    // Inline function 'kotlin.collections.set' call
    // Inline function 'kotlin.collections.getOrPut' call
    var this_0 = this.pd2_1;
    var value_0 = this_0.h3(descriptor);
    var tmp;
    if (value_0 == null) {
      // Inline function 'kotlinx.serialization.json.internal.DescriptorSchemaCache.set.<anonymous>' call
      var answer = createMapForCache(2);
      this_0.j3(descriptor, answer);
      tmp = answer;
    } else {
      tmp = value_0;
    }
    var this_1 = tmp;
    var key_0 = key instanceof Key ? key : THROW_CCE();
    var value_1 = !(value == null) ? value : THROW_CCE();
    this_1.j3(key_0, value_1);
  }
  qd2(descriptor, key, defaultValue) {
    var tmp18_safe_receiver = this.cd4(descriptor, key);
    if (tmp18_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      return tmp18_safe_receiver;
    }
    var value = defaultValue();
    this.bd4(descriptor, key, value);
    return value;
  }
  cd4(descriptor, key) {
    var tmp19_safe_receiver = this.pd2_1.h3(descriptor);
    var tmp;
    if (tmp19_safe_receiver == null) {
      tmp = null;
    } else {
      tmp = tmp19_safe_receiver.h3(key instanceof Key ? key : THROW_CCE());
    }
    var tmp_0 = tmp;
    return !(tmp_0 == null) ? tmp_0 : null;
  }
}
class DiscriminatorHolder {
  constructor(discriminatorToSkip) {
    this.dd4_1 = discriminatorToSkip;
  }
}
class StreamingJsonDecoder extends AbstractDecoder {
  constructor(json, mode, lexer, descriptor, discriminatorHolder) {
    super();
    this.kcx_1 = json;
    this.lcx_1 = mode;
    this.mcx_1 = lexer;
    this.ncx_1 = this.kcx_1.ucg();
    this.ocx_1 = -1;
    this.pcx_1 = discriminatorHolder;
    this.qcx_1 = this.kcx_1.ecx_1;
    this.rcx_1 = this.qcx_1.vcy_1 ? null : new JsonElementMarker(descriptor);
  }
  hcz() {
    return this.kcx_1;
  }
  ucg() {
    return this.ncx_1;
  }
  icz() {
    return (new JsonTreeReader(this.kcx_1.ecx_1, this.mcx_1)).w1x();
  }
  ecg(deserializer) {
    try {
      var tmp;
      if (!(deserializer instanceof AbstractPolymorphicSerializer)) {
        tmp = true;
      } else {
        tmp = this.kcx_1.ecx_1.ycy_1;
      }
      if (tmp) {
        return deserializer.lcc(this);
      }
      var discriminator = classDiscriminator(deserializer.jcc(), this.kcx_1);
      var tmp0_elvis_lhs = this.mcx_1.md4(discriminator, this.qcx_1.scy_1);
      var tmp_0;
      if (tmp0_elvis_lhs == null) {
        var tmp$ret$0;
        $l$block: {
          // Inline function 'kotlinx.serialization.json.internal.decodeSerializableValuePolymorphic' call
          var deserializer_0 = isInterface(deserializer, DeserializationStrategy) ? deserializer : THROW_CCE();
          var tmp_1;
          if (!(deserializer_0 instanceof AbstractPolymorphicSerializer)) {
            tmp_1 = true;
          } else {
            tmp_1 = this.hcz().ecx_1.ycy_1;
          }
          if (tmp_1) {
            tmp$ret$0 = deserializer_0.lcc(this);
            break $l$block;
          }
          var discriminator_0 = classDiscriminator(deserializer_0.jcc(), this.hcz());
          // Inline function 'kotlinx.serialization.json.internal.cast' call
          var value = this.icz();
          var serialName = deserializer_0.jcc().ice();
          if (!(value instanceof JsonObject)) {
            var tmp_2 = getKClass(JsonObject).nf();
            var tmp_3 = getKClassFromExpression(value).nf();
            // Inline function 'kotlinx.serialization.json.internal.StreamingJsonDecoder.decodeSerializableValue.<anonymous>' call
            var tmp$ret$1 = this.mcx_1.tcx_1.bd3();
            throw JsonDecodingException_0(-1, 'Expected ' + tmp_2 + ', but had ' + tmp_3 + ' as the serialized body of ' + serialName + ' at element: ' + tmp$ret$1, toString(value));
          }
          var jsonTree = value;
          var tmp16_safe_receiver = jsonTree.oi(discriminator_0);
          var tmp17_safe_receiver = tmp16_safe_receiver == null ? null : get_jsonPrimitive(tmp16_safe_receiver);
          var type = tmp17_safe_receiver == null ? null : get_contentOrNull(tmp17_safe_receiver);
          var tmp_4;
          try {
            tmp_4 = findPolymorphicSerializer(deserializer_0, this, type);
          } catch ($p) {
            var tmp_5;
            if ($p instanceof SerializationException) {
              var it = $p;
              throw JsonDecodingException_0(-1, ensureNotNull(it.message), jsonTree.toString());
            } else {
              throw $p;
            }
          }
          var tmp_6 = tmp_4;
          var actualSerializer = isInterface(tmp_6, DeserializationStrategy) ? tmp_6 : THROW_CCE();
          tmp$ret$0 = readPolymorphicJson(this.hcz(), discriminator_0, jsonTree, actualSerializer);
        }
        return tmp$ret$0;
      } else {
        tmp_0 = tmp0_elvis_lhs;
      }
      var type_0 = tmp_0;
      var tmp_7;
      try {
        tmp_7 = findPolymorphicSerializer(deserializer, this, type_0);
      } catch ($p) {
        var tmp_8;
        if ($p instanceof SerializationException) {
          var it_0 = $p;
          var message = removeSuffix(substringBefore(ensureNotNull(it_0.message), _Char___init__impl__6a9atx(10)), '.');
          var hint = substringAfter(ensureNotNull(it_0.message), _Char___init__impl__6a9atx(10), '');
          this.mcx_1.bd2(message, VOID, hint);
        } else {
          throw $p;
        }
        tmp_7 = tmp_8;
      }
      var tmp_9 = tmp_7;
      var actualSerializer_0 = isInterface(tmp_9, DeserializationStrategy) ? tmp_9 : THROW_CCE();
      this.pcx_1 = new DiscriminatorHolder(discriminator);
      return actualSerializer_0.lcc(this);
    } catch ($p) {
      if ($p instanceof MissingFieldException) {
        var e = $p;
        if (contains_0(ensureNotNull(e.message), 'at path'))
          throw e;
        throw MissingFieldException.xcd(e.vcd_1, plus(e.message, ' at path: ') + this.mcx_1.tcx_1.bd3(), e);
      } else {
        throw $p;
      }
    }
  }
  fcg(descriptor) {
    var newMode = switchMode(this.kcx_1, descriptor);
    this.mcx_1.tcx_1.wd2(descriptor);
    this.mcx_1.ed4(newMode.pd4_1);
    checkLeadingComma(this);
    var tmp;
    switch (newMode.t3_1) {
      case 1:
      case 2:
      case 3:
        tmp = new StreamingJsonDecoder(this.kcx_1, newMode, this.mcx_1, descriptor, this.pcx_1);
        break;
      default:
        var tmp_0;
        if (this.lcx_1.equals(newMode) && this.kcx_1.ecx_1.vcy_1) {
          tmp_0 = this;
        } else {
          tmp_0 = new StreamingJsonDecoder(this.kcx_1, newMode, this.mcx_1, descriptor, this.pcx_1);
        }

        tmp = tmp_0;
        break;
    }
    return tmp;
  }
  gcg(descriptor) {
    if (this.kcx_1.ecx_1.rcy_1 && descriptor.qce() === 0) {
      skipLeftoverElements(this, descriptor);
    }
    if (this.mcx_1.fd4() && !this.kcx_1.ecx_1.ecz_1) {
      invalidTrailingComma(this.mcx_1, '');
    }
    this.mcx_1.ed4(this.lcx_1.qd4_1);
    this.mcx_1.tcx_1.ad3();
  }
  qcf() {
    var tmp;
    var tmp21_safe_receiver = this.rcx_1;
    var tmp0_elvis_lhs = tmp21_safe_receiver == null ? null : tmp21_safe_receiver.xd1_1;
    if (!(tmp0_elvis_lhs == null ? false : tmp0_elvis_lhs)) {
      tmp = !this.mcx_1.rd4();
    } else {
      tmp = false;
    }
    return tmp;
  }
  rcf() {
    return null;
  }
  rcg(descriptor, index, deserializer, previousValue) {
    var isMapKey = this.lcx_1.equals(WriteMode_MAP_getInstance()) && (index & 1) === 0;
    if (isMapKey) {
      this.mcx_1.tcx_1.zd2();
    }
    var value = super.rcg(descriptor, index, deserializer, previousValue);
    if (isMapKey) {
      this.mcx_1.tcx_1.yd2(value);
    }
    return value;
  }
  wcg(descriptor) {
    var index;
    switch (this.lcx_1.t3_1) {
      case 0:
        index = decodeObjectIndex(this, descriptor);
        break;
      case 2:
        index = decodeMapIndex(this);
        break;
      default:
        index = decodeListIndex(this);
        break;
    }
    if (!this.lcx_1.equals(WriteMode_MAP_getInstance())) {
      this.mcx_1.tcx_1.xd2(index);
    }
    return index;
  }
  scf() {
    return this.mcx_1.sd4();
  }
  tcf() {
    var value = this.mcx_1.tcz();
    if (!value.equals(toLong(value.o4()))) {
      this.mcx_1.bd2("Failed to parse byte for input '" + value.toString() + "'");
    }
    return value.o4();
  }
  ucf() {
    var value = this.mcx_1.tcz();
    if (!value.equals(toLong(value.p4()))) {
      this.mcx_1.bd2("Failed to parse short for input '" + value.toString() + "'");
    }
    return value.p4();
  }
  vcf() {
    var value = this.mcx_1.tcz();
    if (!value.equals(toLong(value.l2()))) {
      this.mcx_1.bd2("Failed to parse int for input '" + value.toString() + "'");
    }
    return value.l2();
  }
  wcf() {
    return this.mcx_1.tcz();
  }
  xcf() {
    var tmp$ret$4;
    $l$block: {
      // Inline function 'kotlinx.serialization.json.internal.parseString' call
      var this_0 = this.mcx_1;
      var input = this_0.vd3();
      try {
        // Inline function 'kotlinx.serialization.json.internal.StreamingJsonDecoder.decodeFloat.<anonymous>' call
        // Inline function 'kotlin.text.toFloat' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp$ret$4 = toDouble(input);
        break $l$block;
      } catch ($p) {
        if ($p instanceof IllegalArgumentException) {
          var e = $p;
          this_0.bd2("Failed to parse type '" + 'float' + "' for input '" + input + "'");
        } else {
          throw $p;
        }
      }
    }
    var result = tmp$ret$4;
    var specialFp = this.kcx_1.ecx_1.acz_1;
    if (specialFp || isFinite(result))
      return result;
    throwInvalidFloatingPointDecoded(this.mcx_1, result);
  }
  ycf() {
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlinx.serialization.json.internal.parseString' call
      var this_0 = this.mcx_1;
      var input = this_0.vd3();
      try {
        // Inline function 'kotlinx.serialization.json.internal.StreamingJsonDecoder.decodeDouble.<anonymous>' call
        tmp$ret$1 = toDouble(input);
        break $l$block;
      } catch ($p) {
        if ($p instanceof IllegalArgumentException) {
          var e = $p;
          this_0.bd2("Failed to parse type '" + 'double' + "' for input '" + input + "'");
        } else {
          throw $p;
        }
      }
    }
    var result = tmp$ret$1;
    var specialFp = this.kcx_1.ecx_1.acz_1;
    if (specialFp || isFinite_0(result))
      return result;
    throwInvalidFloatingPointDecoded(this.mcx_1, result);
  }
  zcf() {
    var string = this.mcx_1.vd3();
    if (!(string.length === 1)) {
      this.mcx_1.bd2("Expected single char, but got '" + string + "'");
    }
    return charSequenceGet(string, 0);
  }
  acg() {
    var tmp;
    if (this.qcx_1.scy_1) {
      tmp = this.mcx_1.ld4();
    } else {
      tmp = this.mcx_1.ud3();
    }
    return tmp;
  }
  ccg(descriptor) {
    return get_isUnsignedNumber(descriptor) ? new JsonDecoderForUnsignedTypes(this.mcx_1, this.kcx_1) : super.ccg(descriptor);
  }
  bcg(enumDescriptor) {
    return getJsonNameIndexOrThrow(enumDescriptor, this.kcx_1, this.acg(), ' at path ' + this.mcx_1.tcx_1.bd3());
  }
}
class JsonDecoderForUnsignedTypes extends AbstractDecoder {
  constructor(lexer, json) {
    super();
    this.td4_1 = lexer;
    this.ud4_1 = json.ucg();
  }
  ucg() {
    return this.ud4_1;
  }
  wcg(descriptor) {
    var message = 'unsupported';
    throw IllegalStateException.l5(toString(message));
  }
  vcf() {
    var tmp$ret$2;
    $l$block: {
      // Inline function 'kotlinx.serialization.json.internal.parseString' call
      var this_0 = this.td4_1;
      var input = this_0.vd3();
      try {
        // Inline function 'kotlinx.serialization.json.internal.JsonDecoderForUnsignedTypes.decodeInt.<anonymous>' call
        // Inline function 'kotlin.UInt.toInt' call
        var this_1 = toUInt(input);
        tmp$ret$2 = _UInt___get_data__impl__f0vqqw(this_1);
        break $l$block;
      } catch ($p) {
        if ($p instanceof IllegalArgumentException) {
          var e = $p;
          this_0.bd2("Failed to parse type '" + 'UInt' + "' for input '" + input + "'");
        } else {
          throw $p;
        }
      }
    }
    return tmp$ret$2;
  }
  wcf() {
    var tmp$ret$2;
    $l$block: {
      // Inline function 'kotlinx.serialization.json.internal.parseString' call
      var this_0 = this.td4_1;
      var input = this_0.vd3();
      try {
        // Inline function 'kotlinx.serialization.json.internal.JsonDecoderForUnsignedTypes.decodeLong.<anonymous>' call
        // Inline function 'kotlin.ULong.toLong' call
        var this_1 = toULong(input);
        tmp$ret$2 = _ULong___get_data__impl__fggpzb(this_1);
        break $l$block;
      } catch ($p) {
        if ($p instanceof IllegalArgumentException) {
          var e = $p;
          this_0.bd2("Failed to parse type '" + 'ULong' + "' for input '" + input + "'");
        } else {
          throw $p;
        }
      }
    }
    return tmp$ret$2;
  }
  tcf() {
    var tmp$ret$2;
    $l$block: {
      // Inline function 'kotlinx.serialization.json.internal.parseString' call
      var this_0 = this.td4_1;
      var input = this_0.vd3();
      try {
        // Inline function 'kotlinx.serialization.json.internal.JsonDecoderForUnsignedTypes.decodeByte.<anonymous>' call
        // Inline function 'kotlin.UByte.toByte' call
        var this_1 = toUByte(input);
        tmp$ret$2 = _UByte___get_data__impl__jof9qr(this_1);
        break $l$block;
      } catch ($p) {
        if ($p instanceof IllegalArgumentException) {
          var e = $p;
          this_0.bd2("Failed to parse type '" + 'UByte' + "' for input '" + input + "'");
        } else {
          throw $p;
        }
      }
    }
    return tmp$ret$2;
  }
  ucf() {
    var tmp$ret$2;
    $l$block: {
      // Inline function 'kotlinx.serialization.json.internal.parseString' call
      var this_0 = this.td4_1;
      var input = this_0.vd3();
      try {
        // Inline function 'kotlinx.serialization.json.internal.JsonDecoderForUnsignedTypes.decodeShort.<anonymous>' call
        // Inline function 'kotlin.UShort.toShort' call
        var this_1 = toUShort(input);
        tmp$ret$2 = _UShort___get_data__impl__g0245(this_1);
        break $l$block;
      } catch ($p) {
        if ($p instanceof IllegalArgumentException) {
          var e = $p;
          this_0.bd2("Failed to parse type '" + 'UShort' + "' for input '" + input + "'");
        } else {
          throw $p;
        }
      }
    }
    return tmp$ret$2;
  }
}
class StreamingJsonEncoder extends AbstractEncoder {
  static vd4(composer, json, mode, modeReuseCache) {
    var $this = this.ycg();
    $this.cd3_1 = composer;
    $this.dd3_1 = json;
    $this.ed3_1 = mode;
    $this.fd3_1 = modeReuseCache;
    $this.gd3_1 = $this.dd3_1.ucg();
    $this.hd3_1 = $this.dd3_1.ecx_1;
    $this.id3_1 = false;
    $this.jd3_1 = null;
    $this.kd3_1 = null;
    var i = $this.ed3_1.t3_1;
    if (!($this.fd3_1 == null)) {
      if (!($this.fd3_1[i] === null) || !($this.fd3_1[i] === $this)) {
        $this.fd3_1[i] = $this;
      }
    }
    return $this;
  }
  hcz() {
    return this.dd3_1;
  }
  static ld3(output, json, mode, modeReuseCache) {
    return this.vd4(Composer_0(output, json), json, mode, modeReuseCache);
  }
  ucg() {
    return this.gd3_1;
  }
  dci(descriptor, index) {
    return this.hd3_1.qcy_1;
  }
  ych(serializer, value) {
    $l$block: {
      // Inline function 'kotlinx.serialization.json.internal.encodePolymorphically' call
      if (this.hcz().ecx_1.ycy_1) {
        serializer.kcc(this, value);
        break $l$block;
      }
      var isPolymorphicSerializer = serializer instanceof AbstractPolymorphicSerializer;
      var tmp;
      if (isPolymorphicSerializer) {
        tmp = !this.hcz().ecx_1.gcz_1.equals(ClassDiscriminatorMode_NONE_getInstance());
      } else {
        var tmp_0;
        switch (this.hcz().ecx_1.gcz_1.t3_1) {
          case 0:
          case 2:
            tmp_0 = false;
            break;
          case 1:
            // Inline function 'kotlin.let' call

            // Inline function 'kotlin.contracts.contract' call

            // Inline function 'kotlinx.serialization.json.internal.encodePolymorphically.<anonymous>' call

            var it = serializer.jcc().oce();
            tmp_0 = equals(it, CLASS_getInstance()) || equals(it, OBJECT_getInstance());
            break;
          default:
            noWhenBranchMatchedException();
            break;
        }
        tmp = tmp_0;
      }
      var needDiscriminator = tmp;
      var baseClassDiscriminator = needDiscriminator ? classDiscriminator(serializer.jcc(), this.hcz()) : null;
      var tmp_1;
      if (isPolymorphicSerializer) {
        var casted = serializer instanceof AbstractPolymorphicSerializer ? serializer : THROW_CCE();
        $l$block_0: {
          // Inline function 'kotlin.requireNotNull' call
          // Inline function 'kotlin.contracts.contract' call
          if (value == null) {
            // Inline function 'kotlinx.serialization.json.internal.encodePolymorphically.<anonymous>' call
            var message = 'Value for serializer ' + toString(serializer.jcc()) + ' should always be non-null. Please report issue to the kotlinx.serialization tracker.';
            throw IllegalArgumentException.l(toString(message));
          } else {
            break $l$block_0;
          }
        }
        var actual = findPolymorphicSerializer_0(casted, this, value);
        if (!(baseClassDiscriminator == null)) {
          validateIfSealed$accessor$1rk9rdt(serializer, actual, baseClassDiscriminator);
        }
        checkKind(actual.jcc().oce());
        tmp_1 = isInterface(actual, SerializationStrategy) ? actual : THROW_CCE();
      } else {
        tmp_1 = serializer;
      }
      var actualSerializer = tmp_1;
      if (!(baseClassDiscriminator == null)) {
        // Inline function 'kotlinx.serialization.json.internal.StreamingJsonEncoder.encodeSerializableValue.<anonymous>' call
        var serialName = actualSerializer.jcc().ice();
        this.jd3_1 = baseClassDiscriminator;
        this.kd3_1 = serialName;
      }
      actualSerializer.kcc(this, value);
    }
  }
  fcg(descriptor) {
    var newMode = switchMode(this.dd3_1, descriptor);
    if (!(newMode.pd4_1 === _Char___init__impl__6a9atx(0))) {
      this.cd3_1.yd0(newMode.pd4_1);
      this.cd3_1.z3c();
    }
    var discriminator = this.jd3_1;
    if (!(discriminator == null)) {
      var tmp0_elvis_lhs = this.kd3_1;
      encodeTypeInfo(this, discriminator, tmp0_elvis_lhs == null ? descriptor.ice() : tmp0_elvis_lhs);
      this.jd3_1 = null;
      this.kd3_1 = null;
    }
    if (this.ed3_1.equals(newMode)) {
      return this;
    }
    var tmp25_safe_receiver = this.fd3_1;
    var tmp1_elvis_lhs = tmp25_safe_receiver == null ? null : tmp25_safe_receiver[newMode.t3_1];
    return tmp1_elvis_lhs == null ? StreamingJsonEncoder.vd4(this.cd3_1, this.dd3_1, newMode, this.fd3_1) : tmp1_elvis_lhs;
  }
  gcg(descriptor) {
    if (!(this.ed3_1.qd4_1 === _Char___init__impl__6a9atx(0))) {
      this.cd3_1.ud0();
      this.cd3_1.wd0();
      this.cd3_1.yd0(this.ed3_1.qd4_1);
    }
  }
  zcg(descriptor, index) {
    switch (this.ed3_1.t3_1) {
      case 1:
        if (!this.cd3_1.td0_1) {
          this.cd3_1.yd0(_Char___init__impl__6a9atx(44));
        }

        this.cd3_1.vd0();
        break;
      case 2:
        if (!this.cd3_1.td0_1) {
          var tmp = this;
          var tmp_0;
          if ((index % 2 | 0) === 0) {
            this.cd3_1.yd0(_Char___init__impl__6a9atx(44));
            this.cd3_1.vd0();
            tmp_0 = true;
          } else {
            this.cd3_1.yd0(_Char___init__impl__6a9atx(58));
            this.cd3_1.xd0();
            tmp_0 = false;
          }
          tmp.id3_1 = tmp_0;
        } else {
          this.id3_1 = true;
          this.cd3_1.vd0();
        }

        break;
      case 3:
        if (index === 0)
          this.id3_1 = true;
        if (index === 1) {
          this.cd3_1.yd0(_Char___init__impl__6a9atx(44));
          this.cd3_1.xd0();
          this.id3_1 = false;
        }

        break;
      default:
        if (!this.cd3_1.td0_1) {
          this.cd3_1.yd0(_Char___init__impl__6a9atx(44));
        }

        this.cd3_1.vd0();
        this.kch(getJsonElementName(descriptor, this.dd3_1, index));
        this.cd3_1.yd0(_Char___init__impl__6a9atx(58));
        this.cd3_1.xd0();
        break;
    }
    return true;
  }
  zch(descriptor, index, serializer, value) {
    if (!(value == null) || this.hd3_1.vcy_1) {
      super.zch(descriptor, index, serializer, value);
    }
  }
  mch(descriptor) {
    var tmp;
    if (get_isUnsignedNumber(descriptor)) {
      // Inline function 'kotlinx.serialization.json.internal.StreamingJsonEncoder.composerAs' call
      var tmp_0;
      var tmp_1 = this.cd3_1;
      if (tmp_1 instanceof ComposerForUnsignedNumbers) {
        tmp_0 = this.cd3_1;
      } else {
        var p0 = this.cd3_1.sd0_1;
        var p1 = this.id3_1;
        tmp_0 = new ComposerForUnsignedNumbers(p0, p1);
      }
      var tmp$ret$1 = tmp_0;
      tmp = StreamingJsonEncoder.vd4(tmp$ret$1, this.dd3_1, this.ed3_1, null);
    } else if (get_isUnquotedLiteral(descriptor)) {
      // Inline function 'kotlinx.serialization.json.internal.StreamingJsonEncoder.composerAs' call
      var tmp_2;
      var tmp_3 = this.cd3_1;
      if (tmp_3 instanceof ComposerForUnquotedLiterals) {
        tmp_2 = this.cd3_1;
      } else {
        var p0_0 = this.cd3_1.sd0_1;
        var p1_0 = this.id3_1;
        tmp_2 = new ComposerForUnquotedLiterals(p0_0, p1_0);
      }
      var tmp$ret$3 = tmp_2;
      tmp = StreamingJsonEncoder.vd4(tmp$ret$3, this.dd3_1, this.ed3_1, null);
    } else if (!(this.jd3_1 == null)) {
      // Inline function 'kotlin.apply' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'kotlinx.serialization.json.internal.StreamingJsonEncoder.encodeInline.<anonymous>' call
      this.kd3_1 = descriptor.ice();
      tmp = this;
    } else {
      tmp = super.mch(descriptor);
    }
    return tmp;
  }
  bch() {
    this.cd3_1.ad1('null');
  }
  cch(value) {
    if (this.id3_1) {
      this.kch(value.toString());
    } else {
      this.cd3_1.jd1(value);
    }
  }
  dch(value) {
    if (this.id3_1) {
      this.kch(value.toString());
    } else {
      this.cd3_1.ed1(value);
    }
  }
  ech(value) {
    if (this.id3_1) {
      this.kch(value.toString());
    } else {
      this.cd3_1.gd1(value);
    }
  }
  fch(value) {
    if (this.id3_1) {
      this.kch(value.toString());
    } else {
      this.cd3_1.hd1(value);
    }
  }
  gch(value) {
    if (this.id3_1) {
      this.kch(value.toString());
    } else {
      this.cd3_1.id1(value);
    }
  }
  hch(value) {
    if (this.id3_1) {
      this.kch(value.toString());
    } else {
      this.cd3_1.cd1(value);
    }
    if (!this.hd3_1.acz_1 && !isFinite(value)) {
      throw InvalidFloatingPointEncoded(value, toString(this.cd3_1.sd0_1));
    }
  }
  ich(value) {
    if (this.id3_1) {
      this.kch(value.toString());
    } else {
      this.cd3_1.dd1(value);
    }
    if (!this.hd3_1.acz_1 && !isFinite_0(value)) {
      throw InvalidFloatingPointEncoded(value, toString(this.cd3_1.sd0_1));
    }
  }
  jch(value) {
    this.kch(toString_1(value));
  }
  kch(value) {
    return this.cd3_1.kd1(value);
  }
  lch(enumDescriptor, index) {
    this.kch(enumDescriptor.jce(index));
  }
}
class AbstractJsonTreeDecoder extends NamedValueDecoder {
  constructor(json, value, polymorphicDiscriminator) {
    polymorphicDiscriminator = polymorphicDiscriminator === VOID ? null : polymorphicDiscriminator;
    super();
    this.yd4_1 = json;
    this.zd4_1 = value;
    this.ad5_1 = polymorphicDiscriminator;
    this.bd5_1 = this.hcz().ecx_1;
  }
  hcz() {
    return this.yd4_1;
  }
  u1() {
    return this.zd4_1;
  }
  ucg() {
    return this.hcz().ucg();
  }
  dd5() {
    var tmp28_safe_receiver = this.lcu();
    var tmp;
    if (tmp28_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.currentObject.<anonymous>' call
      tmp = this.ed5(tmp28_safe_receiver);
    }
    var tmp0_elvis_lhs = tmp;
    return tmp0_elvis_lhs == null ? this.u1() : tmp0_elvis_lhs;
  }
  cd5(currentTag) {
    return this.ncu() + ('.' + currentTag);
  }
  icz() {
    return this.dd5();
  }
  ecg(deserializer) {
    var tmp$ret$0;
    $l$block: {
      // Inline function 'kotlinx.serialization.json.internal.decodeSerializableValuePolymorphic' call
      var tmp;
      if (!(deserializer instanceof AbstractPolymorphicSerializer)) {
        tmp = true;
      } else {
        tmp = this.hcz().ecx_1.ycy_1;
      }
      if (tmp) {
        tmp$ret$0 = deserializer.lcc(this);
        break $l$block;
      }
      var discriminator = classDiscriminator(deserializer.jcc(), this.hcz());
      // Inline function 'kotlinx.serialization.json.internal.cast' call
      var value = this.icz();
      var serialName = deserializer.jcc().ice();
      if (!(value instanceof JsonObject)) {
        var tmp_0 = getKClass(JsonObject).nf();
        var tmp_1 = getKClassFromExpression(value).nf();
        var tmp$ret$1 = this.ncu();
        throw JsonDecodingException_0(-1, 'Expected ' + tmp_0 + ', but had ' + tmp_1 + ' as the serialized body of ' + serialName + ' at element: ' + tmp$ret$1, toString(value));
      }
      var jsonTree = value;
      var tmp16_safe_receiver = jsonTree.oi(discriminator);
      var tmp17_safe_receiver = tmp16_safe_receiver == null ? null : get_jsonPrimitive(tmp16_safe_receiver);
      var type = tmp17_safe_receiver == null ? null : get_contentOrNull(tmp17_safe_receiver);
      var tmp_2;
      try {
        tmp_2 = findPolymorphicSerializer(deserializer, this, type);
      } catch ($p) {
        var tmp_3;
        if ($p instanceof SerializationException) {
          var it = $p;
          throw JsonDecodingException_0(-1, ensureNotNull(it.message), jsonTree.toString());
        } else {
          throw $p;
        }
      }
      var tmp_4 = tmp_2;
      var actualSerializer = isInterface(tmp_4, DeserializationStrategy) ? tmp_4 : THROW_CCE();
      tmp$ret$0 = readPolymorphicJson(this.hcz(), discriminator, jsonTree, actualSerializer);
    }
    return tmp$ret$0;
  }
  mcu(parentName, childName) {
    return childName;
  }
  fcg(descriptor) {
    var currentObject = this.dd5();
    var tmp29_subject = descriptor.oce();
    var tmp;
    var tmp_0;
    if (equals(tmp29_subject, LIST_getInstance())) {
      tmp_0 = true;
    } else {
      tmp_0 = tmp29_subject instanceof PolymorphicKind;
    }
    if (tmp_0) {
      var tmp_1 = this.hcz();
      // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.cast' call
      // Inline function 'kotlinx.serialization.json.internal.cast' call
      var serialName = descriptor.ice();
      if (!(currentObject instanceof JsonArray)) {
        var tmp_2 = getKClass(JsonArray).nf();
        var tmp_3 = getKClassFromExpression(currentObject).nf();
        // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.cast.<anonymous>' call
        var tmp$ret$0 = this.ncu();
        throw JsonDecodingException_0(-1, 'Expected ' + tmp_2 + ', but had ' + tmp_3 + ' as the serialized body of ' + serialName + ' at element: ' + tmp$ret$0, toString(currentObject));
      }
      tmp = new JsonTreeListDecoder(tmp_1, currentObject);
    } else {
      if (equals(tmp29_subject, MAP_getInstance())) {
        // Inline function 'kotlinx.serialization.json.internal.selectMapMode' call
        var this_0 = this.hcz();
        var keyDescriptor = carrierDescriptor(descriptor.mce(0), this_0.ucg());
        var keyKind = keyDescriptor.oce();
        var tmp_4;
        var tmp_5;
        if (keyKind instanceof PrimitiveKind) {
          tmp_5 = true;
        } else {
          tmp_5 = equals(keyKind, ENUM_getInstance());
        }
        if (tmp_5) {
          // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.beginStructure.<anonymous>' call
          var tmp_6 = this.hcz();
          // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.cast' call
          // Inline function 'kotlinx.serialization.json.internal.cast' call
          var serialName_0 = descriptor.ice();
          if (!(currentObject instanceof JsonObject)) {
            var tmp_7 = getKClass(JsonObject).nf();
            var tmp_8 = getKClassFromExpression(currentObject).nf();
            // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.cast.<anonymous>' call
            var tmp$ret$3 = this.ncu();
            throw JsonDecodingException_0(-1, 'Expected ' + tmp_7 + ', but had ' + tmp_8 + ' as the serialized body of ' + serialName_0 + ' at element: ' + tmp$ret$3, toString(currentObject));
          }
          tmp_4 = new JsonTreeMapDecoder(tmp_6, currentObject);
        } else {
          if (this_0.ecx_1.tcy_1) {
            // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.beginStructure.<anonymous>' call
            var tmp_9 = this.hcz();
            // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.cast' call
            // Inline function 'kotlinx.serialization.json.internal.cast' call
            var serialName_1 = descriptor.ice();
            if (!(currentObject instanceof JsonArray)) {
              var tmp_10 = getKClass(JsonArray).nf();
              var tmp_11 = getKClassFromExpression(currentObject).nf();
              // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.cast.<anonymous>' call
              var tmp$ret$7 = this.ncu();
              throw JsonDecodingException_0(-1, 'Expected ' + tmp_10 + ', but had ' + tmp_11 + ' as the serialized body of ' + serialName_1 + ' at element: ' + tmp$ret$7, toString(currentObject));
            }
            tmp_4 = new JsonTreeListDecoder(tmp_9, currentObject);
          } else {
            throw InvalidKeyKindException(keyDescriptor);
          }
        }
        tmp = tmp_4;
      } else {
        var tmp_12 = this.hcz();
        // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.cast' call
        // Inline function 'kotlinx.serialization.json.internal.cast' call
        var serialName_2 = descriptor.ice();
        if (!(currentObject instanceof JsonObject)) {
          var tmp_13 = getKClass(JsonObject).nf();
          var tmp_14 = getKClassFromExpression(currentObject).nf();
          // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.cast.<anonymous>' call
          var tmp$ret$12 = this.ncu();
          throw JsonDecodingException_0(-1, 'Expected ' + tmp_13 + ', but had ' + tmp_14 + ' as the serialized body of ' + serialName_2 + ' at element: ' + tmp$ret$12, toString(currentObject));
        }
        tmp = new JsonTreeDecoder(tmp_12, currentObject, this.ad5_1);
      }
    }
    return tmp;
  }
  gcg(descriptor) {
  }
  qcf() {
    var tmp = this.dd5();
    return !(tmp instanceof JsonNull);
  }
  fd5(tag, enumDescriptor) {
    var tmp = this.hcz();
    // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.getPrimitiveValue' call
    // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.cast' call
    var value = this.ed5(tag);
    // Inline function 'kotlinx.serialization.json.internal.cast' call
    var serialName = enumDescriptor.ice();
    if (!(value instanceof JsonPrimitive)) {
      var tmp_0 = getKClass(JsonPrimitive).nf();
      var tmp_1 = getKClassFromExpression(value).nf();
      // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.cast.<anonymous>' call
      var tmp$ret$0 = this.cd5(tag);
      throw JsonDecodingException_0(-1, 'Expected ' + tmp_0 + ', but had ' + tmp_1 + ' as the serialized body of ' + serialName + ' at element: ' + tmp$ret$0, toString(value));
    }
    return getJsonNameIndexOrThrow(enumDescriptor, tmp, value.e41());
  }
  zcu(tag, enumDescriptor) {
    return this.fd5((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE(), enumDescriptor);
  }
  gd5(tag) {
    return !(this.ed5(tag) === JsonNull_getInstance());
  }
  pcu(tag) {
    return this.gd5((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE());
  }
  hd5(tag) {
    var tmp$ret$4;
    $l$block: {
      // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.getPrimitiveValue' call
      // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.cast' call
      // Inline function 'kotlinx.serialization.json.internal.cast' call
      var value = this.ed5(tag);
      if (!(value instanceof JsonPrimitive)) {
        var tmp = getKClass(JsonPrimitive).nf();
        var tmp_0 = getKClassFromExpression(value).nf();
        // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.cast.<anonymous>' call
        var tmp$ret$0 = this.cd5(tag);
        throw JsonDecodingException_0(-1, 'Expected ' + tmp + ', but had ' + tmp_0 + ' as the serialized body of ' + 'boolean' + ' at element: ' + tmp$ret$0, toString(value));
      }
      var literal = value;
      try {
        var tmp0_elvis_lhs = get_booleanOrNull(literal);
        var tmp_1;
        if (tmp0_elvis_lhs == null) {
          unparsedPrimitive(this, literal, 'boolean', tag);
        } else {
          tmp_1 = tmp0_elvis_lhs;
        }
        tmp$ret$4 = tmp_1;
        break $l$block;
      } catch ($p) {
        if ($p instanceof IllegalArgumentException) {
          var e = $p;
          unparsedPrimitive(this, literal, 'boolean', tag);
        } else {
          throw $p;
        }
      }
    }
    return tmp$ret$4;
  }
  qcu(tag) {
    return this.hd5((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE());
  }
  id5(tag) {
    var tmp$ret$4;
    $l$block: {
      // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.getPrimitiveValue' call
      // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.cast' call
      // Inline function 'kotlinx.serialization.json.internal.cast' call
      var value = this.ed5(tag);
      if (!(value instanceof JsonPrimitive)) {
        var tmp = getKClass(JsonPrimitive).nf();
        var tmp_0 = getKClassFromExpression(value).nf();
        // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.cast.<anonymous>' call
        var tmp$ret$0 = this.cd5(tag);
        throw JsonDecodingException_0(-1, 'Expected ' + tmp + ', but had ' + tmp_0 + ' as the serialized body of ' + 'byte' + ' at element: ' + tmp$ret$0, toString(value));
      }
      var literal = value;
      try {
        // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.decodeTaggedByte.<anonymous>' call
        var result = get_int(literal);
        var tmp0_elvis_lhs = (-128 <= result ? result <= 127 : false) ? toByte(result) : null;
        var tmp_1;
        if (tmp0_elvis_lhs == null) {
          unparsedPrimitive(this, literal, 'byte', tag);
        } else {
          tmp_1 = tmp0_elvis_lhs;
        }
        tmp$ret$4 = tmp_1;
        break $l$block;
      } catch ($p) {
        if ($p instanceof IllegalArgumentException) {
          var e = $p;
          unparsedPrimitive(this, literal, 'byte', tag);
        } else {
          throw $p;
        }
      }
    }
    return tmp$ret$4;
  }
  rcu(tag) {
    return this.id5((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE());
  }
  jd5(tag) {
    var tmp$ret$4;
    $l$block: {
      // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.getPrimitiveValue' call
      // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.cast' call
      // Inline function 'kotlinx.serialization.json.internal.cast' call
      var value = this.ed5(tag);
      if (!(value instanceof JsonPrimitive)) {
        var tmp = getKClass(JsonPrimitive).nf();
        var tmp_0 = getKClassFromExpression(value).nf();
        // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.cast.<anonymous>' call
        var tmp$ret$0 = this.cd5(tag);
        throw JsonDecodingException_0(-1, 'Expected ' + tmp + ', but had ' + tmp_0 + ' as the serialized body of ' + 'short' + ' at element: ' + tmp$ret$0, toString(value));
      }
      var literal = value;
      try {
        // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.decodeTaggedShort.<anonymous>' call
        var result = get_int(literal);
        var tmp0_elvis_lhs = (-32768 <= result ? result <= 32767 : false) ? toShort(result) : null;
        var tmp_1;
        if (tmp0_elvis_lhs == null) {
          unparsedPrimitive(this, literal, 'short', tag);
        } else {
          tmp_1 = tmp0_elvis_lhs;
        }
        tmp$ret$4 = tmp_1;
        break $l$block;
      } catch ($p) {
        if ($p instanceof IllegalArgumentException) {
          var e = $p;
          unparsedPrimitive(this, literal, 'short', tag);
        } else {
          throw $p;
        }
      }
    }
    return tmp$ret$4;
  }
  scu(tag) {
    return this.jd5((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE());
  }
  kd5(tag) {
    var tmp$ret$4;
    $l$block: {
      // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.getPrimitiveValue' call
      // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.cast' call
      // Inline function 'kotlinx.serialization.json.internal.cast' call
      var value = this.ed5(tag);
      if (!(value instanceof JsonPrimitive)) {
        var tmp = getKClass(JsonPrimitive).nf();
        var tmp_0 = getKClassFromExpression(value).nf();
        // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.cast.<anonymous>' call
        var tmp$ret$0 = this.cd5(tag);
        throw JsonDecodingException_0(-1, 'Expected ' + tmp + ', but had ' + tmp_0 + ' as the serialized body of ' + 'int' + ' at element: ' + tmp$ret$0, toString(value));
      }
      var literal = value;
      try {
        // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.decodeTaggedInt.<anonymous>' call
        var tmp0_elvis_lhs = get_int(literal);
        var tmp_1;
        if (tmp0_elvis_lhs == null) {
          unparsedPrimitive(this, literal, 'int', tag);
        } else {
          tmp_1 = tmp0_elvis_lhs;
        }
        tmp$ret$4 = tmp_1;
        break $l$block;
      } catch ($p) {
        if ($p instanceof IllegalArgumentException) {
          var e = $p;
          unparsedPrimitive(this, literal, 'int', tag);
        } else {
          throw $p;
        }
      }
    }
    return tmp$ret$4;
  }
  tcu(tag) {
    return this.kd5((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE());
  }
  ld5(tag) {
    var tmp$ret$4;
    $l$block: {
      // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.getPrimitiveValue' call
      // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.cast' call
      // Inline function 'kotlinx.serialization.json.internal.cast' call
      var value = this.ed5(tag);
      if (!(value instanceof JsonPrimitive)) {
        var tmp = getKClass(JsonPrimitive).nf();
        var tmp_0 = getKClassFromExpression(value).nf();
        // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.cast.<anonymous>' call
        var tmp$ret$0 = this.cd5(tag);
        throw JsonDecodingException_0(-1, 'Expected ' + tmp + ', but had ' + tmp_0 + ' as the serialized body of ' + 'long' + ' at element: ' + tmp$ret$0, toString(value));
      }
      var literal = value;
      try {
        // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.decodeTaggedLong.<anonymous>' call
        var tmp0_elvis_lhs = get_long(literal);
        var tmp_1;
        if (tmp0_elvis_lhs == null) {
          unparsedPrimitive(this, literal, 'long', tag);
        } else {
          tmp_1 = tmp0_elvis_lhs;
        }
        tmp$ret$4 = tmp_1;
        break $l$block;
      } catch ($p) {
        if ($p instanceof IllegalArgumentException) {
          var e = $p;
          unparsedPrimitive(this, literal, 'long', tag);
        } else {
          throw $p;
        }
      }
    }
    return tmp$ret$4;
  }
  ucu(tag) {
    return this.ld5((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE());
  }
  md5(tag) {
    var tmp$ret$4;
    $l$block: {
      // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.getPrimitiveValue' call
      // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.cast' call
      // Inline function 'kotlinx.serialization.json.internal.cast' call
      var value = this.ed5(tag);
      if (!(value instanceof JsonPrimitive)) {
        var tmp = getKClass(JsonPrimitive).nf();
        var tmp_0 = getKClassFromExpression(value).nf();
        // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.cast.<anonymous>' call
        var tmp$ret$0 = this.cd5(tag);
        throw JsonDecodingException_0(-1, 'Expected ' + tmp + ', but had ' + tmp_0 + ' as the serialized body of ' + 'float' + ' at element: ' + tmp$ret$0, toString(value));
      }
      var literal = value;
      try {
        // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.decodeTaggedFloat.<anonymous>' call
        var tmp0_elvis_lhs = get_float(literal);
        var tmp_1;
        if (tmp0_elvis_lhs == null) {
          unparsedPrimitive(this, literal, 'float', tag);
        } else {
          tmp_1 = tmp0_elvis_lhs;
        }
        tmp$ret$4 = tmp_1;
        break $l$block;
      } catch ($p) {
        if ($p instanceof IllegalArgumentException) {
          var e = $p;
          unparsedPrimitive(this, literal, 'float', tag);
        } else {
          throw $p;
        }
      }
    }
    var result = tmp$ret$4;
    var specialFp = this.hcz().ecx_1.acz_1;
    if (specialFp || isFinite(result))
      return result;
    throw InvalidFloatingPointDecoded(result, tag, toString(this.dd5()));
  }
  vcu(tag) {
    return this.md5((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE());
  }
  nd5(tag) {
    var tmp$ret$4;
    $l$block: {
      // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.getPrimitiveValue' call
      // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.cast' call
      // Inline function 'kotlinx.serialization.json.internal.cast' call
      var value = this.ed5(tag);
      if (!(value instanceof JsonPrimitive)) {
        var tmp = getKClass(JsonPrimitive).nf();
        var tmp_0 = getKClassFromExpression(value).nf();
        // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.cast.<anonymous>' call
        var tmp$ret$0 = this.cd5(tag);
        throw JsonDecodingException_0(-1, 'Expected ' + tmp + ', but had ' + tmp_0 + ' as the serialized body of ' + 'double' + ' at element: ' + tmp$ret$0, toString(value));
      }
      var literal = value;
      try {
        // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.decodeTaggedDouble.<anonymous>' call
        var tmp0_elvis_lhs = get_double(literal);
        var tmp_1;
        if (tmp0_elvis_lhs == null) {
          unparsedPrimitive(this, literal, 'double', tag);
        } else {
          tmp_1 = tmp0_elvis_lhs;
        }
        tmp$ret$4 = tmp_1;
        break $l$block;
      } catch ($p) {
        if ($p instanceof IllegalArgumentException) {
          var e = $p;
          unparsedPrimitive(this, literal, 'double', tag);
        } else {
          throw $p;
        }
      }
    }
    var result = tmp$ret$4;
    var specialFp = this.hcz().ecx_1.acz_1;
    if (specialFp || isFinite_0(result))
      return result;
    throw InvalidFloatingPointDecoded(result, tag, toString(this.dd5()));
  }
  wcu(tag) {
    return this.nd5((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE());
  }
  od5(tag) {
    var tmp$ret$4;
    $l$block: {
      // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.getPrimitiveValue' call
      // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.cast' call
      // Inline function 'kotlinx.serialization.json.internal.cast' call
      var value = this.ed5(tag);
      if (!(value instanceof JsonPrimitive)) {
        var tmp = getKClass(JsonPrimitive).nf();
        var tmp_0 = getKClassFromExpression(value).nf();
        // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.cast.<anonymous>' call
        var tmp$ret$0 = this.cd5(tag);
        throw JsonDecodingException_0(-1, 'Expected ' + tmp + ', but had ' + tmp_0 + ' as the serialized body of ' + 'char' + ' at element: ' + tmp$ret$0, toString(value));
      }
      var literal = value;
      try {
        // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.decodeTaggedChar.<anonymous>' call
        var tmp0_elvis_lhs = new Char(single(literal.e41()));
        var tmp_1;
        if (tmp0_elvis_lhs == null) {
          unparsedPrimitive(this, literal, 'char', tag);
        } else {
          tmp_1 = tmp0_elvis_lhs;
        }
        tmp$ret$4 = tmp_1.n2_1;
        break $l$block;
      } catch ($p) {
        if ($p instanceof IllegalArgumentException) {
          var e = $p;
          unparsedPrimitive(this, literal, 'char', tag);
        } else {
          throw $p;
        }
      }
    }
    return tmp$ret$4;
  }
  xcu(tag) {
    return this.od5((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE());
  }
  pd5(tag) {
    // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.cast' call
    // Inline function 'kotlinx.serialization.json.internal.cast' call
    var value = this.ed5(tag);
    if (!(value instanceof JsonPrimitive)) {
      var tmp = getKClass(JsonPrimitive).nf();
      var tmp_0 = getKClassFromExpression(value).nf();
      // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.cast.<anonymous>' call
      var tmp$ret$0 = this.cd5(tag);
      throw JsonDecodingException_0(-1, 'Expected ' + tmp + ', but had ' + tmp_0 + ' as the serialized body of ' + 'string' + ' at element: ' + tmp$ret$0, toString(value));
    }
    var value_0 = value;
    if (!(value_0 instanceof JsonLiteral))
      throw JsonDecodingException_0(-1, "Expected string value for a non-null key '" + tag + "', got null literal instead at element: " + this.cd5(tag), toString(this.dd5()));
    if (!value_0.ncz_1 && !this.hcz().ecx_1.scy_1) {
      throw JsonDecodingException_0(-1, "String literal for key '" + tag + "' should be quoted at element: " + this.cd5(tag) + ".\nUse 'isLenient = true' in 'Json {}' builder to accept non-compliant JSON.", toString(this.dd5()));
    }
    return value_0.pcz_1;
  }
  ycu(tag) {
    return this.pd5((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE());
  }
  qd5(tag, inlineDescriptor) {
    var tmp;
    if (get_isUnsignedNumber(inlineDescriptor)) {
      var tmp_0 = this.hcz();
      // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.getPrimitiveValue' call
      // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.cast' call
      var value = this.ed5(tag);
      // Inline function 'kotlinx.serialization.json.internal.cast' call
      var serialName = inlineDescriptor.ice();
      if (!(value instanceof JsonPrimitive)) {
        var tmp_1 = getKClass(JsonPrimitive).nf();
        var tmp_2 = getKClassFromExpression(value).nf();
        // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.cast.<anonymous>' call
        var tmp$ret$0 = this.cd5(tag);
        throw JsonDecodingException_0(-1, 'Expected ' + tmp_1 + ', but had ' + tmp_2 + ' as the serialized body of ' + serialName + ' at element: ' + tmp$ret$0, toString(value));
      }
      var lexer = StringJsonLexer_0(tmp_0, value.e41());
      tmp = new JsonDecoderForUnsignedTypes(lexer, this.hcz());
    } else {
      tmp = super.acv(tag, inlineDescriptor);
    }
    return tmp;
  }
  acv(tag, inlineDescriptor) {
    return this.qd5((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE(), inlineDescriptor);
  }
  ccg(descriptor) {
    return !(this.lcu() == null) ? super.ccg(descriptor) : (new JsonPrimitiveDecoder(this.hcz(), this.u1(), this.ad5_1)).ccg(descriptor);
  }
}
class JsonTreeDecoder extends AbstractJsonTreeDecoder {
  constructor(json, value, polymorphicDiscriminator, polyDescriptor) {
    polymorphicDiscriminator = polymorphicDiscriminator === VOID ? null : polymorphicDiscriminator;
    polyDescriptor = polyDescriptor === VOID ? null : polyDescriptor;
    super(json, value, polymorphicDiscriminator);
    this.xd5_1 = value;
    this.yd5_1 = polyDescriptor;
    this.zd5_1 = 0;
    this.ad6_1 = false;
  }
  u1() {
    return this.xd5_1;
  }
  wcg(descriptor) {
    while (this.zd5_1 < descriptor.qce()) {
      var _unary__edvuaz = this.zd5_1;
      this.zd5_1 = _unary__edvuaz + 1 | 0;
      var name = this.gcu(descriptor, _unary__edvuaz);
      var index = this.zd5_1 - 1 | 0;
      this.ad6_1 = false;
      var tmp;
      var tmp_0;
      // Inline function 'kotlin.collections.contains' call
      // Inline function 'kotlin.collections.containsKey' call
      var this_0 = this.u1();
      if ((isInterface(this_0, KtMap) ? this_0 : THROW_CCE()).f3(name)) {
        tmp_0 = true;
      } else {
        tmp_0 = absenceIsNull(this, descriptor, index);
      }
      if (tmp_0) {
        tmp = !this.bd5_1.xcy_1 || !coerceInputValue_0(this, descriptor, index, name);
      } else {
        tmp = false;
      }
      if (tmp) {
        return index;
      }
    }
    return -1;
  }
  qcf() {
    return !this.ad6_1 && super.qcf();
  }
  hcu(descriptor, index) {
    var strategy = namingStrategy(descriptor, this.hcz());
    var baseName = descriptor.jce(index);
    if (strategy == null) {
      if (!this.bd5_1.bcz_1)
        return baseName;
      if (this.u1().i3().z2(baseName))
        return baseName;
    }
    var deserializationNamesMap_0 = deserializationNamesMap(this.hcz(), descriptor);
    // Inline function 'kotlin.collections.find' call
    var this_0 = this.u1().i3();
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.collections.firstOrNull' call
      var tmp0_iterator = this_0.a1();
      while (tmp0_iterator.b1()) {
        var element = tmp0_iterator.c1();
        // Inline function 'kotlinx.serialization.json.internal.JsonTreeDecoder.elementName.<anonymous>' call
        if (deserializationNamesMap_0.h3(element) === index) {
          tmp$ret$1 = element;
          break $l$block;
        }
      }
      tmp$ret$1 = null;
    }
    var tmp31_safe_receiver = tmp$ret$1;
    if (tmp31_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      return tmp31_safe_receiver;
    }
    var fallbackName = strategy == null ? null : strategy.sd2(descriptor, index, baseName);
    return fallbackName == null ? baseName : fallbackName;
  }
  ed5(tag) {
    return getValue(this.u1(), tag);
  }
  fcg(descriptor) {
    if (descriptor === this.yd5_1) {
      var tmp = this.hcz();
      // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.cast' call
      var value = this.dd5();
      // Inline function 'kotlinx.serialization.json.internal.cast' call
      var serialName = this.yd5_1.ice();
      if (!(value instanceof JsonObject)) {
        var tmp_0 = getKClass(JsonObject).nf();
        var tmp_1 = getKClassFromExpression(value).nf();
        // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.cast.<anonymous>' call
        var tmp$ret$0 = this.ncu();
        throw JsonDecodingException_0(-1, 'Expected ' + tmp_0 + ', but had ' + tmp_1 + ' as the serialized body of ' + serialName + ' at element: ' + tmp$ret$0, toString(value));
      }
      return new JsonTreeDecoder(tmp, value, this.ad5_1, this.yd5_1);
    }
    return super.fcg(descriptor);
  }
  gcg(descriptor) {
    var tmp;
    if (this.bd5_1.rcy_1) {
      tmp = true;
    } else {
      var tmp_0 = descriptor.oce();
      tmp = tmp_0 instanceof PolymorphicKind;
    }
    if (tmp)
      return Unit_instance;
    var strategy = namingStrategy(descriptor, this.hcz());
    var tmp_1;
    if (strategy == null && !this.bd5_1.bcz_1) {
      tmp_1 = jsonCachedSerialNames(descriptor);
    } else if (!(strategy == null)) {
      tmp_1 = deserializationNamesMap(this.hcz(), descriptor).i3();
    } else {
      var tmp_2 = jsonCachedSerialNames(descriptor);
      // Inline function 'kotlin.collections.orEmpty' call
      var tmp33_safe_receiver = get_schemaCache(this.hcz()).cd4(descriptor, get_JsonDeserializationNamesKey());
      var tmp0_elvis_lhs = tmp33_safe_receiver == null ? null : tmp33_safe_receiver.i3();
      var tmp$ret$0 = tmp0_elvis_lhs == null ? emptySet() : tmp0_elvis_lhs;
      tmp_1 = plus_0(tmp_2, tmp$ret$0);
    }
    var names = tmp_1;
    var _iterator__ex2g4s = this.u1().i3().a1();
    while (_iterator__ex2g4s.b1()) {
      var key = _iterator__ex2g4s.c1();
      if (!names.z2(key) && !(key === this.ad5_1)) {
        throw UnknownKeyException(key, this.u1().toString());
      }
    }
  }
}
class JsonTreeListDecoder extends AbstractJsonTreeDecoder {
  constructor(json, value) {
    super(json, value);
    this.hd6_1 = value;
    this.id6_1 = this.hd6_1.e1();
    this.jd6_1 = -1;
  }
  u1() {
    return this.hd6_1;
  }
  hcu(descriptor, index) {
    return index.toString();
  }
  ed5(tag) {
    return this.hd6_1.d1(toInt(tag));
  }
  wcg(descriptor) {
    while (this.jd6_1 < (this.id6_1 - 1 | 0)) {
      this.jd6_1 = this.jd6_1 + 1 | 0;
      return this.jd6_1;
    }
    return -1;
  }
}
class JsonPrimitiveDecoder extends AbstractJsonTreeDecoder {
  constructor(json, value, polymorphicDiscriminator) {
    polymorphicDiscriminator = polymorphicDiscriminator === VOID ? null : polymorphicDiscriminator;
    super(json, value, polymorphicDiscriminator);
    this.qd6_1 = value;
    this.bcv('primitive');
  }
  u1() {
    return this.qd6_1;
  }
  wcg(descriptor) {
    return 0;
  }
  ed5(tag) {
    // Inline function 'kotlin.require' call
    // Inline function 'kotlin.contracts.contract' call
    if (!(tag === 'primitive')) {
      // Inline function 'kotlinx.serialization.json.internal.JsonPrimitiveDecoder.currentElement.<anonymous>' call
      var message = "This input can only handle primitives with 'primitive' tag";
      throw IllegalArgumentException.l(toString(message));
    }
    return this.qd6_1;
  }
}
class JsonTreeMapDecoder extends JsonTreeDecoder {
  constructor(json, value) {
    super(json, value);
    this.bd7_1 = value;
    this.cd7_1 = toList(this.bd7_1.i3());
    this.dd7_1 = imul(this.cd7_1.e1(), 2);
    this.ed7_1 = -1;
  }
  u1() {
    return this.bd7_1;
  }
  hcu(descriptor, index) {
    var i = index / 2 | 0;
    return this.cd7_1.d1(i);
  }
  wcg(descriptor) {
    while (this.ed7_1 < (this.dd7_1 - 1 | 0)) {
      this.ed7_1 = this.ed7_1 + 1 | 0;
      return this.ed7_1;
    }
    return -1;
  }
  ed5(tag) {
    return (this.ed7_1 % 2 | 0) === 0 ? JsonPrimitive_0(tag) : getValue(this.bd7_1, tag);
  }
  gcg(descriptor) {
  }
}
class WriteMode extends Enum {
  constructor(name, ordinal, begin, end) {
    super(name, ordinal);
    this.pd4_1 = begin;
    this.qd4_1 = end;
  }
}
class AbstractJsonLexer {
  constructor() {
    this.scx_1 = 0;
    this.tcx_1 = new JsonPath();
    this.ucx_1 = null;
    this.vcx_1 = StringBuilder.f();
  }
  id7() {
  }
  fd4() {
    var current = this.jd7();
    var source = this.gd7();
    if (current >= charSequenceLength(source) || current === -1)
      return false;
    if (charSequenceGet(source, current) === _Char___init__impl__6a9atx(44)) {
      this.scx_1 = this.scx_1 + 1 | 0;
      return true;
    }
    return false;
  }
  kd7(c) {
    return c === _Char___init__impl__6a9atx(125) || c === _Char___init__impl__6a9atx(93) || (c === _Char___init__impl__6a9atx(58) || c === _Char___init__impl__6a9atx(44)) ? false : true;
  }
  wcx() {
    var nextToken = this.wd3();
    if (!(nextToken === 10)) {
      this.bd2('Expected EOF after parsing, but had ' + toString_1(charSequenceGet(this.gd7(), this.scx_1 - 1 | 0)) + ' instead');
    }
  }
  sd3(expected) {
    var token = this.wd3();
    if (!(token === expected)) {
      this.ld7(expected);
    }
    return token;
  }
  md7(expected) {
    if (this.scx_1 > 0 && expected === _Char___init__impl__6a9atx(34)) {
      var tmp$ret$1;
      $l$block: {
        // Inline function 'kotlinx.serialization.json.internal.AbstractJsonLexer.withPositionRollback' call
        var snapshot = this.scx_1;
        try {
          // Inline function 'kotlinx.serialization.json.internal.AbstractJsonLexer.unexpectedToken.<anonymous>' call
          this.scx_1 = this.scx_1 - 1 | 0;
          tmp$ret$1 = this.vd3();
          break $l$block;
        }finally {
          this.scx_1 = snapshot;
        }
      }
      var inputLiteral = tmp$ret$1;
      if (inputLiteral === 'null') {
        this.ad2("Expected string literal but 'null' literal was found", this.scx_1 - 1 | 0, "Use 'coerceInputValues = true' in 'Json {}' builder to coerce nulls if property has a default value.");
      }
    }
    this.ld7(charToTokenClass(expected));
  }
  nd7(expectedToken, wasConsumed) {
    var expected = tokenDescription(expectedToken);
    var position = wasConsumed ? this.scx_1 - 1 | 0 : this.scx_1;
    var s = this.scx_1 === charSequenceLength(this.gd7()) || position < 0 ? 'EOF' : toString_1(charSequenceGet(this.gd7(), position));
    this.bd2('Expected ' + expected + ", but had '" + s + "' instead", position);
  }
  ld7(expectedToken, wasConsumed, $super) {
    wasConsumed = wasConsumed === VOID ? true : wasConsumed;
    return $super === VOID ? this.nd7(expectedToken, wasConsumed) : $super.nd7.call(this, expectedToken, wasConsumed);
  }
  rd3() {
    var source = this.gd7();
    var cpos = this.scx_1;
    $l$loop_0: while (true) {
      cpos = this.hd7(cpos);
      if (cpos === -1)
        break $l$loop_0;
      var ch = charSequenceGet(source, cpos);
      if (ch === _Char___init__impl__6a9atx(32) || ch === _Char___init__impl__6a9atx(10) || ch === _Char___init__impl__6a9atx(13) || ch === _Char___init__impl__6a9atx(9)) {
        cpos = cpos + 1 | 0;
        continue $l$loop_0;
      }
      this.scx_1 = cpos;
      return charToTokenClass(ch);
    }
    this.scx_1 = cpos;
    return 10;
  }
  gd4(doConsume) {
    var current = this.jd7();
    current = this.hd7(current);
    var len = charSequenceLength(this.gd7()) - current | 0;
    if (len < 4 || current === -1)
      return false;
    var inductionVariable = 0;
    if (inductionVariable <= 3)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (!(charSequenceGet('null', i) === charSequenceGet(this.gd7(), current + i | 0)))
          return false;
      }
       while (inductionVariable <= 3);
    if (len > 4 && charToTokenClass(charSequenceGet(this.gd7(), current + 4 | 0)) === 0)
      return false;
    if (doConsume) {
      this.scx_1 = current + 4 | 0;
    }
    return true;
  }
  rd4(doConsume, $super) {
    doConsume = doConsume === VOID ? true : doConsume;
    return $super === VOID ? this.gd4(doConsume) : $super.gd4.call(this, doConsume);
  }
  hd4(isLenient) {
    var token = this.rd3();
    var tmp;
    if (isLenient) {
      if (!(token === 1) && !(token === 0))
        return null;
      tmp = this.vd3();
    } else {
      if (!(token === 1))
        return null;
      tmp = this.ud3();
    }
    var string = tmp;
    this.ucx_1 = string;
    return string;
  }
  od7() {
    this.ucx_1 = null;
  }
  mh(startPos, endPos) {
    // Inline function 'kotlin.text.substring' call
    var this_0 = this.gd7();
    return toString(charSequenceSubSequence(this_0, startPos, endPos));
  }
  ud3() {
    if (!(this.ucx_1 == null)) {
      return takePeeked(this);
    }
    return this.kd4();
  }
  consumeString2(source, startPosition, current) {
    var currentPosition = current;
    var lastPosition = startPosition;
    var char = charSequenceGet(source, currentPosition);
    var usedAppend = false;
    while (!(char === _Char___init__impl__6a9atx(34))) {
      if (char === _Char___init__impl__6a9atx(92)) {
        usedAppend = true;
        currentPosition = this.hd7(appendEscape(this, lastPosition, currentPosition));
        if (currentPosition === -1) {
          this.bd2('Unexpected EOF', currentPosition);
        }
        lastPosition = currentPosition;
      } else {
        currentPosition = currentPosition + 1 | 0;
        if (currentPosition >= charSequenceLength(source)) {
          usedAppend = true;
          this.fd7(lastPosition, currentPosition);
          currentPosition = this.hd7(currentPosition);
          if (currentPosition === -1) {
            this.bd2('Unexpected EOF', currentPosition);
          }
          lastPosition = currentPosition;
        }
      }
      char = charSequenceGet(source, currentPosition);
    }
    var tmp;
    if (!usedAppend) {
      tmp = this.mh(lastPosition, currentPosition);
    } else {
      tmp = decodedString(this, lastPosition, currentPosition);
    }
    var string = tmp;
    this.scx_1 = currentPosition + 1 | 0;
    return string;
  }
  ld4() {
    var result = this.vd3();
    if (result === 'null' && wasUnquotedString(this)) {
      this.bd2("Unexpected 'null' value instead of string literal");
    }
    return result;
  }
  vd3() {
    if (!(this.ucx_1 == null)) {
      return takePeeked(this);
    }
    var current = this.jd7();
    if (current >= charSequenceLength(this.gd7()) || current === -1) {
      this.bd2('EOF', current);
    }
    var token = charToTokenClass(charSequenceGet(this.gd7(), current));
    if (token === 1) {
      return this.ud3();
    }
    if (!(token === 0)) {
      this.bd2('Expected beginning of the string, but got ' + toString_1(charSequenceGet(this.gd7(), current)));
    }
    var usedAppend = false;
    while (charToTokenClass(charSequenceGet(this.gd7(), current)) === 0) {
      current = current + 1 | 0;
      if (current >= charSequenceLength(this.gd7())) {
        usedAppend = true;
        this.fd7(this.scx_1, current);
        var eof = this.hd7(current);
        if (eof === -1) {
          this.scx_1 = current;
          return decodedString(this, 0, 0);
        } else {
          current = eof;
        }
      }
    }
    var tmp;
    if (!usedAppend) {
      tmp = this.mh(this.scx_1, current);
    } else {
      tmp = decodedString(this, this.scx_1, current);
    }
    var result = tmp;
    this.scx_1 = current;
    return result;
  }
  fd7(fromIndex, toIndex) {
    this.vcx_1.dh(this.gd7(), fromIndex, toIndex);
  }
  jd4(allowLenientStrings) {
    // Inline function 'kotlin.collections.mutableListOf' call
    var tokenStack = ArrayList.i1();
    var lastToken = this.rd3();
    if (!(lastToken === 8) && !(lastToken === 6)) {
      this.vd3();
      return Unit_instance;
    }
    $l$loop: while (true) {
      lastToken = this.rd3();
      if (lastToken === 1) {
        if (allowLenientStrings)
          this.vd3();
        else
          this.kd4();
        continue $l$loop;
      }
      var tmp40_subject = lastToken;
      if (tmp40_subject === 8 || tmp40_subject === 6) {
        tokenStack.h(lastToken);
      } else if (tmp40_subject === 9) {
        if (!(last(tokenStack) === 8))
          throw JsonDecodingException_0(this.scx_1, 'found ] instead of } at path: ' + this.tcx_1.toString(), this.gd7());
        removeLast(tokenStack);
      } else if (tmp40_subject === 7) {
        if (!(last(tokenStack) === 6))
          throw JsonDecodingException_0(this.scx_1, 'found } instead of ] at path: ' + this.tcx_1.toString(), this.gd7());
        removeLast(tokenStack);
      } else if (tmp40_subject === 10) {
        this.bd2('Unexpected end of input due to malformed JSON during ignoring unknown keys');
      }
      this.wd3();
      if (tokenStack.e1() === 0)
        return Unit_instance;
    }
  }
  toString() {
    return "JsonReader(source='" + toString(this.gd7()) + "', currentPosition=" + this.scx_1 + ')';
  }
  id4(key) {
    var processed = this.mh(0, this.scx_1);
    var lastIndexOf_0 = lastIndexOf(processed, key);
    this.ad2("Encountered an unknown key '" + key + "'", lastIndexOf_0, "Use 'ignoreUnknownKeys = true' in 'Json {}' builder to ignore unknown keys.");
  }
  ad2(message, position, hint) {
    var tmp;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(hint) === 0) {
      tmp = '';
    } else {
      tmp = '\n' + hint;
    }
    var hintMessage = tmp;
    throw JsonDecodingException_0(position, message + ' at path: ' + this.tcx_1.bd3() + hintMessage, this.gd7());
  }
  bd2(message, position, hint, $super) {
    position = position === VOID ? this.scx_1 : position;
    hint = hint === VOID ? '' : hint;
    return $super === VOID ? this.ad2(message, position, hint) : $super.ad2.call(this, message, position, hint);
  }
  tcz() {
    var current = this.jd7();
    current = this.hd7(current);
    if (current >= charSequenceLength(this.gd7()) || current === -1) {
      this.bd2('EOF');
    }
    var tmp;
    if (charSequenceGet(this.gd7(), current) === _Char___init__impl__6a9atx(34)) {
      current = current + 1 | 0;
      if (current === charSequenceLength(this.gd7())) {
        this.bd2('EOF');
      }
      tmp = true;
    } else {
      tmp = false;
    }
    var hasQuotation = tmp;
    var accumulator = new Long(0, 0);
    var exponentAccumulator = new Long(0, 0);
    var isNegative = false;
    var isExponentPositive = false;
    var hasExponent = false;
    var start = current;
    $l$loop_4: while (!(current === charSequenceLength(this.gd7()))) {
      var ch = charSequenceGet(this.gd7(), current);
      if ((ch === _Char___init__impl__6a9atx(101) || ch === _Char___init__impl__6a9atx(69)) && !hasExponent) {
        if (current === start) {
          this.bd2('Unexpected symbol ' + toString_1(ch) + ' in numeric literal');
        }
        isExponentPositive = true;
        hasExponent = true;
        current = current + 1 | 0;
        continue $l$loop_4;
      }
      if (ch === _Char___init__impl__6a9atx(45) && hasExponent) {
        if (current === start) {
          this.bd2("Unexpected symbol '-' in numeric literal");
        }
        isExponentPositive = false;
        current = current + 1 | 0;
        continue $l$loop_4;
      }
      if (ch === _Char___init__impl__6a9atx(43) && hasExponent) {
        if (current === start) {
          this.bd2("Unexpected symbol '+' in numeric literal");
        }
        isExponentPositive = true;
        current = current + 1 | 0;
        continue $l$loop_4;
      }
      if (ch === _Char___init__impl__6a9atx(45)) {
        if (!(current === start)) {
          this.bd2("Unexpected symbol '-' in numeric literal");
        }
        isNegative = true;
        current = current + 1 | 0;
        continue $l$loop_4;
      }
      var token = charToTokenClass(ch);
      if (!(token === 0))
        break $l$loop_4;
      current = current + 1 | 0;
      var digit = Char__minus_impl_a2frrh(ch, _Char___init__impl__6a9atx(48));
      if (!(0 <= digit ? digit <= 9 : false)) {
        this.bd2("Unexpected symbol '" + toString_1(ch) + "' in numeric literal");
      }
      if (hasExponent) {
        // Inline function 'kotlin.Long.plus' call
        // Inline function 'kotlin.Long.times' call
        exponentAccumulator = exponentAccumulator.b4(toLong(10)).a4(toLong(digit));
        continue $l$loop_4;
      }
      // Inline function 'kotlin.Long.minus' call
      // Inline function 'kotlin.Long.times' call
      accumulator = accumulator.b4(toLong(10)).a2(toLong(digit));
      if (accumulator.z1(new Long(0, 0)) > 0) {
        this.bd2('Numeric value overflow');
      }
    }
    var hasChars = !(current === start);
    if (start === current || (isNegative && start === (current - 1 | 0))) {
      this.bd2('Expected numeric literal');
    }
    if (hasQuotation) {
      if (!hasChars) {
        this.bd2('EOF');
      }
      if (!(charSequenceGet(this.gd7(), current) === _Char___init__impl__6a9atx(34))) {
        this.bd2('Expected closing quotation mark');
      }
      current = current + 1 | 0;
    }
    this.scx_1 = current;
    if (hasExponent) {
      var doubleAccumulator = accumulator.r4() * consumeNumericLiteral$calculateExponent(exponentAccumulator, isExponentPositive);
      if (doubleAccumulator > (new Long(-1, 2147483647)).r4() || doubleAccumulator < (new Long(0, -2147483648)).r4()) {
        this.bd2('Numeric value overflow');
      }
      // Inline function 'kotlin.math.floor' call
      if (!(Math.floor(doubleAccumulator) === doubleAccumulator)) {
        this.bd2("Can't convert " + doubleAccumulator + ' to Long');
      }
      accumulator = numberToLong(doubleAccumulator);
    }
    var tmp_0;
    if (isNegative) {
      tmp_0 = accumulator;
    } else if (!accumulator.equals(new Long(0, -2147483648))) {
      tmp_0 = accumulator.g4();
    } else {
      this.bd2('Numeric value overflow');
    }
    return tmp_0;
  }
  sd4() {
    var current = this.jd7();
    if (current === charSequenceLength(this.gd7())) {
      this.bd2('EOF');
    }
    var tmp;
    if (charSequenceGet(this.gd7(), current) === _Char___init__impl__6a9atx(34)) {
      current = current + 1 | 0;
      tmp = true;
    } else {
      tmp = false;
    }
    var hasQuotation = tmp;
    var result = consumeBoolean2(this, current);
    if (hasQuotation) {
      if (this.scx_1 === charSequenceLength(this.gd7())) {
        this.bd2('EOF');
      }
      if (!(charSequenceGet(this.gd7(), this.scx_1) === _Char___init__impl__6a9atx(34))) {
        this.bd2('Expected closing quotation mark');
      }
      this.scx_1 = this.scx_1 + 1 | 0;
    }
    return result;
  }
}
class CharMappings {
  constructor() {
    CharMappings_instance = this;
    this.pd7_1 = charArray(117);
    this.qd7_1 = new Int8Array(126);
    initEscape(this);
    initCharToToken(this);
  }
}
class StringJsonLexer extends AbstractJsonLexer {
  constructor(source) {
    super();
    this.ad8_1 = source;
  }
  gd7() {
    return this.ad8_1;
  }
  hd7(position) {
    return position < this.gd7().length ? position : -1;
  }
  wd3() {
    var source = this.gd7();
    var cpos = this.scx_1;
    $l$loop: while (!(cpos === -1) && cpos < source.length) {
      var _unary__edvuaz = cpos;
      cpos = _unary__edvuaz + 1 | 0;
      var c = charSequenceGet(source, _unary__edvuaz);
      // Inline function 'kotlinx.serialization.json.internal.AbstractJsonLexer.isWs' call
      if (c === _Char___init__impl__6a9atx(32) || c === _Char___init__impl__6a9atx(10) || c === _Char___init__impl__6a9atx(13) || c === _Char___init__impl__6a9atx(9))
        continue $l$loop;
      this.scx_1 = cpos;
      return charToTokenClass(c);
    }
    this.scx_1 = source.length;
    return 10;
  }
  td3() {
    var current = this.scx_1;
    if (current === -1)
      return false;
    var source = this.gd7();
    $l$loop: while (current < source.length) {
      var c = charSequenceGet(source, current);
      // Inline function 'kotlinx.serialization.json.internal.AbstractJsonLexer.isWs' call
      if (c === _Char___init__impl__6a9atx(32) || c === _Char___init__impl__6a9atx(10) || c === _Char___init__impl__6a9atx(13) || c === _Char___init__impl__6a9atx(9)) {
        current = current + 1 | 0;
        continue $l$loop;
      }
      this.scx_1 = current;
      return this.kd7(c);
    }
    this.scx_1 = current;
    return false;
  }
  jd7() {
    var current = this.scx_1;
    if (current === -1)
      return current;
    var source = this.gd7();
    $l$loop: while (current < source.length) {
      var c = charSequenceGet(source, current);
      // Inline function 'kotlinx.serialization.json.internal.AbstractJsonLexer.isWs' call
      if (c === _Char___init__impl__6a9atx(32) || c === _Char___init__impl__6a9atx(10) || c === _Char___init__impl__6a9atx(13) || c === _Char___init__impl__6a9atx(9)) {
        current = current + 1 | 0;
      } else {
        break $l$loop;
      }
    }
    this.scx_1 = current;
    return current;
  }
  ed4(expected) {
    if (this.scx_1 === -1) {
      this.md7(expected);
    }
    var source = this.gd7();
    var cpos = this.scx_1;
    $l$loop: while (cpos < source.length) {
      var _unary__edvuaz = cpos;
      cpos = _unary__edvuaz + 1 | 0;
      var c = charSequenceGet(source, _unary__edvuaz);
      // Inline function 'kotlinx.serialization.json.internal.AbstractJsonLexer.isWs' call
      if (c === _Char___init__impl__6a9atx(32) || c === _Char___init__impl__6a9atx(10) || c === _Char___init__impl__6a9atx(13) || c === _Char___init__impl__6a9atx(9))
        continue $l$loop;
      this.scx_1 = cpos;
      if (c === expected)
        return Unit_instance;
      this.md7(expected);
    }
    this.scx_1 = -1;
    this.md7(expected);
  }
  kd4() {
    this.ed4(_Char___init__impl__6a9atx(34));
    var current = this.scx_1;
    var closingQuote = indexOf_0(this.gd7(), _Char___init__impl__6a9atx(34), current);
    if (closingQuote === -1) {
      this.vd3();
      this.nd7(1, false);
    }
    var inductionVariable = current;
    if (inductionVariable < closingQuote)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (charSequenceGet(this.gd7(), i) === _Char___init__impl__6a9atx(92)) {
          return this.consumeString2(this.gd7(), this.scx_1, i);
        }
      }
       while (inductionVariable < closingQuote);
    this.scx_1 = closingQuote + 1 | 0;
    // Inline function 'kotlin.text.substring' call
    // Inline function 'kotlin.js.asDynamic' call
    return this.gd7().substring(current, closingQuote);
  }
  md4(keyToMatch, isLenient) {
    var positionSnapshot = this.scx_1;
    try {
      if (!(this.wd3() === 6))
        return null;
      var firstKey = this.hd4(isLenient);
      if (!(firstKey === keyToMatch))
        return null;
      this.od7();
      if (!(this.wd3() === 5))
        return null;
      return this.hd4(isLenient);
    }finally {
      this.scx_1 = positionSnapshot;
      this.od7();
    }
  }
}
class StringJsonLexerWithComments extends StringJsonLexer {
  wd3() {
    var source = this.gd7();
    var cpos = this.jd7();
    if (cpos >= source.length || cpos === -1)
      return 10;
    this.scx_1 = cpos + 1 | 0;
    return charToTokenClass(charSequenceGet(source, cpos));
  }
  td3() {
    var current = this.jd7();
    if (current >= this.gd7().length || current === -1)
      return false;
    return this.kd7(charSequenceGet(this.gd7(), current));
  }
  ed4(expected) {
    var source = this.gd7();
    var current = this.jd7();
    if (current >= source.length || current === -1) {
      this.scx_1 = -1;
      this.md7(expected);
    }
    var c = charSequenceGet(source, current);
    this.scx_1 = current + 1 | 0;
    if (c === expected)
      return Unit_instance;
    else {
      this.md7(expected);
    }
  }
  rd3() {
    var source = this.gd7();
    var cpos = this.jd7();
    if (cpos >= source.length || cpos === -1)
      return 10;
    this.scx_1 = cpos;
    return charToTokenClass(charSequenceGet(source, cpos));
  }
  jd7() {
    var current = this.scx_1;
    if (current === -1)
      return current;
    var source = this.gd7();
    $l$loop_1: while (current < source.length) {
      var c = charSequenceGet(source, current);
      // Inline function 'kotlinx.serialization.json.internal.AbstractJsonLexer.isWs' call
      if (c === _Char___init__impl__6a9atx(32) || c === _Char___init__impl__6a9atx(10) || c === _Char___init__impl__6a9atx(13) || c === _Char___init__impl__6a9atx(9)) {
        current = current + 1 | 0;
        continue $l$loop_1;
      }
      if (c === _Char___init__impl__6a9atx(47) && (current + 1 | 0) < source.length) {
        var tmp43_subject = charSequenceGet(source, current + 1 | 0);
        if (tmp43_subject === _Char___init__impl__6a9atx(47)) {
          current = indexOf_0(source, _Char___init__impl__6a9atx(10), current + 2 | 0);
          if (current === -1) {
            current = source.length;
          } else {
            current = current + 1 | 0;
          }
          continue $l$loop_1;
        } else if (tmp43_subject === _Char___init__impl__6a9atx(42)) {
          current = indexOf(source, '*/', current + 2 | 0);
          if (current === -1) {
            this.scx_1 = source.length;
            this.bd2('Expected end of the block comment: "*/", but had EOF instead');
          } else {
            current = current + 2 | 0;
          }
          continue $l$loop_1;
        }
      }
      break $l$loop_1;
    }
    this.scx_1 = current;
    return current;
  }
}
class JsonToStringWriter {
  constructor() {
    this.jcx_1 = StringBuilder.jc(128);
  }
  fd1(value) {
    this.jcx_1.hh(value);
  }
  zd0(char) {
    this.jcx_1.fc(char);
  }
  bd1(text) {
    this.jcx_1.ec(text);
  }
  ld1(text) {
    printQuoted(this.jcx_1, text);
  }
  n1p() {
    this.jcx_1.oh();
  }
  toString() {
    return this.jcx_1.toString();
  }
}
//endregion
var Default_instance;
function Default_getInstance() {
  if (Default_instance === VOID)
    new Default();
  return Default_instance;
}
function Json_0(from, builderAction) {
  from = from === VOID ? Default_getInstance() : from;
  var builder = new JsonBuilder(from);
  builderAction(builder);
  var conf = builder.pcy();
  return new JsonImpl(conf, builder.ocy_1);
}
function validateConfiguration($this) {
  if (equals($this.ucg(), EmptySerializersModule()))
    return Unit_instance;
  var collector = new PolymorphismValidator($this.ecx_1.ycy_1, $this.ecx_1.zcy_1);
  $this.ucg().mcw(collector);
}
var ClassDiscriminatorMode_NONE_instance;
var ClassDiscriminatorMode_ALL_JSON_OBJECTS_instance;
var ClassDiscriminatorMode_POLYMORPHIC_instance;
var ClassDiscriminatorMode_entriesInitialized;
function ClassDiscriminatorMode_initEntries() {
  if (ClassDiscriminatorMode_entriesInitialized)
    return Unit_instance;
  ClassDiscriminatorMode_entriesInitialized = true;
  ClassDiscriminatorMode_NONE_instance = new ClassDiscriminatorMode('NONE', 0);
  ClassDiscriminatorMode_ALL_JSON_OBJECTS_instance = new ClassDiscriminatorMode('ALL_JSON_OBJECTS', 1);
  ClassDiscriminatorMode_POLYMORPHIC_instance = new ClassDiscriminatorMode('POLYMORPHIC', 2);
}
function ClassDiscriminatorMode_NONE_getInstance() {
  ClassDiscriminatorMode_initEntries();
  return ClassDiscriminatorMode_NONE_instance;
}
function ClassDiscriminatorMode_POLYMORPHIC_getInstance() {
  ClassDiscriminatorMode_initEntries();
  return ClassDiscriminatorMode_POLYMORPHIC_instance;
}
function get_jsonUnquotedLiteralDescriptor() {
  _init_properties_JsonElement_kt__7cbdc2();
  return jsonUnquotedLiteralDescriptor;
}
var jsonUnquotedLiteralDescriptor;
var Companion_instance;
function Companion_getInstance_3() {
  return Companion_instance;
}
var Companion_instance_0;
function Companion_getInstance_4() {
  return Companion_instance_0;
}
function JsonObject$toString$lambda(_destruct__k2r9zo) {
  // Inline function 'kotlin.collections.component1' call
  var k = _destruct__k2r9zo.t1();
  // Inline function 'kotlin.collections.component2' call
  var v = _destruct__k2r9zo.u1();
  // Inline function 'kotlin.text.buildString' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'kotlin.apply' call
  var this_0 = StringBuilder.f();
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'kotlinx.serialization.json.JsonObject.toString.<anonymous>.<anonymous>' call
  printQuoted(this_0, k);
  this_0.fc(_Char___init__impl__6a9atx(58));
  this_0.dc(v);
  return this_0.toString();
}
function _get_$cachedSerializer__te6jhj($this) {
  return $this.lcz_1.u1();
}
function JsonNull$_anonymous__enib48() {
  return JsonNullSerializer_getInstance();
}
var JsonNull_instance;
function JsonNull_getInstance() {
  if (JsonNull_instance === VOID)
    new JsonNull();
  return JsonNull_instance;
}
var Companion_instance_1;
function Companion_getInstance_5() {
  return Companion_instance_1;
}
function JsonPrimitive_0(value) {
  _init_properties_JsonElement_kt__7cbdc2();
  if (value == null)
    return JsonNull_getInstance();
  return new JsonLiteral(value, true);
}
var Companion_instance_2;
function Companion_getInstance_6() {
  return Companion_instance_2;
}
function get_booleanOrNull(_this__u8e3s4) {
  _init_properties_JsonElement_kt__7cbdc2();
  return toBooleanStrictOrNull_0(_this__u8e3s4.e41());
}
function get_int(_this__u8e3s4) {
  _init_properties_JsonElement_kt__7cbdc2();
  // Inline function 'kotlinx.serialization.json.mapExceptions' call
  var tmp;
  try {
    // Inline function 'kotlinx.serialization.json.<get-int>.<anonymous>' call
    tmp = (new StringJsonLexer(_this__u8e3s4.e41())).tcz();
  } catch ($p) {
    var tmp_0;
    if ($p instanceof JsonDecodingException) {
      var e = $p;
      throw NumberFormatException.if(e.message);
    } else {
      throw $p;
    }
  }
  var result = tmp;
  // Inline function 'kotlin.ranges.contains' call
  var this_0 = numberRangeToNumber(-2147483648, 2147483647);
  if (!contains(isInterface(this_0, ClosedRange) ? this_0 : THROW_CCE(), result))
    throw NumberFormatException.if(_this__u8e3s4.e41() + ' is not an Int');
  return result.l2();
}
function get_long(_this__u8e3s4) {
  _init_properties_JsonElement_kt__7cbdc2();
  // Inline function 'kotlinx.serialization.json.mapExceptions' call
  var tmp;
  try {
    // Inline function 'kotlinx.serialization.json.<get-long>.<anonymous>' call
    tmp = (new StringJsonLexer(_this__u8e3s4.e41())).tcz();
  } catch ($p) {
    var tmp_0;
    if ($p instanceof JsonDecodingException) {
      var e = $p;
      throw NumberFormatException.if(e.message);
    } else {
      throw $p;
    }
  }
  return tmp;
}
function get_float(_this__u8e3s4) {
  _init_properties_JsonElement_kt__7cbdc2();
  // Inline function 'kotlin.text.toFloat' call
  var this_0 = _this__u8e3s4.e41();
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return toDouble(this_0);
}
function get_double(_this__u8e3s4) {
  _init_properties_JsonElement_kt__7cbdc2();
  return toDouble(_this__u8e3s4.e41());
}
function get_contentOrNull(_this__u8e3s4) {
  _init_properties_JsonElement_kt__7cbdc2();
  var tmp;
  if (_this__u8e3s4 instanceof JsonNull) {
    tmp = null;
  } else {
    tmp = _this__u8e3s4.e41();
  }
  return tmp;
}
function get_jsonPrimitive(_this__u8e3s4) {
  _init_properties_JsonElement_kt__7cbdc2();
  var tmp0_elvis_lhs = _this__u8e3s4 instanceof JsonPrimitive ? _this__u8e3s4 : null;
  var tmp;
  if (tmp0_elvis_lhs == null) {
    error(_this__u8e3s4, 'JsonPrimitive');
  } else {
    tmp = tmp0_elvis_lhs;
  }
  return tmp;
}
function error(_this__u8e3s4, element) {
  _init_properties_JsonElement_kt__7cbdc2();
  throw IllegalArgumentException.l('Element ' + toString(getKClassFromExpression(_this__u8e3s4)) + ' is not a ' + element);
}
var properties_initialized_JsonElement_kt_abxy8s;
function _init_properties_JsonElement_kt__7cbdc2() {
  if (!properties_initialized_JsonElement_kt_abxy8s) {
    properties_initialized_JsonElement_kt_abxy8s = true;
    jsonUnquotedLiteralDescriptor = InlinePrimitiveDescriptor('kotlinx.serialization.json.JsonUnquotedLiteral', serializer(StringCompanionObject_instance));
  }
}
function JsonElementSerializer$descriptor$lambda($this$buildSerialDescriptor) {
  $this$buildSerialDescriptor.ucc('JsonPrimitive', defer(JsonElementSerializer$descriptor$lambda$lambda));
  $this$buildSerialDescriptor.ucc('JsonNull', defer(JsonElementSerializer$descriptor$lambda$lambda_0));
  $this$buildSerialDescriptor.ucc('JsonLiteral', defer(JsonElementSerializer$descriptor$lambda$lambda_1));
  $this$buildSerialDescriptor.ucc('JsonObject', defer(JsonElementSerializer$descriptor$lambda$lambda_2));
  $this$buildSerialDescriptor.ucc('JsonArray', defer(JsonElementSerializer$descriptor$lambda$lambda_3));
  return Unit_instance;
}
function JsonElementSerializer$descriptor$lambda$lambda() {
  return JsonPrimitiveSerializer_getInstance().ucz_1;
}
function JsonElementSerializer$descriptor$lambda$lambda_0() {
  return JsonNullSerializer_getInstance().vcz_1;
}
function JsonElementSerializer$descriptor$lambda$lambda_1() {
  return JsonLiteralSerializer_getInstance().wcz_1;
}
function JsonElementSerializer$descriptor$lambda$lambda_2() {
  return JsonObjectSerializer_getInstance().xcz_1;
}
function JsonElementSerializer$descriptor$lambda$lambda_3() {
  return JsonArraySerializer_getInstance().ycz_1;
}
var JsonElementSerializer_instance;
function JsonElementSerializer_getInstance() {
  if (JsonElementSerializer_instance === VOID)
    new JsonElementSerializer();
  return JsonElementSerializer_instance;
}
var JsonObjectDescriptor_instance;
function JsonObjectDescriptor_getInstance() {
  if (JsonObjectDescriptor_instance === VOID)
    new JsonObjectDescriptor();
  return JsonObjectDescriptor_instance;
}
var JsonObjectSerializer_instance;
function JsonObjectSerializer_getInstance() {
  if (JsonObjectSerializer_instance === VOID)
    new JsonObjectSerializer();
  return JsonObjectSerializer_instance;
}
var JsonArrayDescriptor_instance;
function JsonArrayDescriptor_getInstance() {
  if (JsonArrayDescriptor_instance === VOID)
    new JsonArrayDescriptor();
  return JsonArrayDescriptor_instance;
}
var JsonArraySerializer_instance;
function JsonArraySerializer_getInstance() {
  if (JsonArraySerializer_instance === VOID)
    new JsonArraySerializer();
  return JsonArraySerializer_instance;
}
function defer(deferred) {
  return new defer$1(deferred);
}
var JsonPrimitiveSerializer_instance;
function JsonPrimitiveSerializer_getInstance() {
  if (JsonPrimitiveSerializer_instance === VOID)
    new JsonPrimitiveSerializer();
  return JsonPrimitiveSerializer_instance;
}
var JsonNullSerializer_instance;
function JsonNullSerializer_getInstance() {
  if (JsonNullSerializer_instance === VOID)
    new JsonNullSerializer();
  return JsonNullSerializer_instance;
}
var JsonLiteralSerializer_instance;
function JsonLiteralSerializer_getInstance() {
  if (JsonLiteralSerializer_instance === VOID)
    new JsonLiteralSerializer();
  return JsonLiteralSerializer_instance;
}
function verify(encoder) {
  asJsonEncoder(encoder);
}
function asJsonDecoder(_this__u8e3s4) {
  var tmp0_elvis_lhs = isInterface(_this__u8e3s4, JsonDecoder) ? _this__u8e3s4 : null;
  var tmp;
  if (tmp0_elvis_lhs == null) {
    throw IllegalStateException.l5('This serializer can be used only with Json format.' + ('Expected Decoder to be JsonDecoder, got ' + toString(getKClassFromExpression(_this__u8e3s4))));
  } else {
    tmp = tmp0_elvis_lhs;
  }
  return tmp;
}
function verify_0(decoder) {
  asJsonDecoder(decoder);
}
function asJsonEncoder(_this__u8e3s4) {
  var tmp0_elvis_lhs = isInterface(_this__u8e3s4, JsonEncoder) ? _this__u8e3s4 : null;
  var tmp;
  if (tmp0_elvis_lhs == null) {
    throw IllegalStateException.l5('This serializer can be used only with Json format.' + ('Expected Encoder to be JsonEncoder, got ' + toString(getKClassFromExpression(_this__u8e3s4))));
  } else {
    tmp = tmp0_elvis_lhs;
  }
  return tmp;
}
function _get_original__l7ku1m($this) {
  // Inline function 'kotlin.getValue' call
  var this_0 = $this.rd0_1;
  original$factory();
  return this_0.u1();
}
function original$factory() {
  return getPropertyCallableRef('original', 1, KProperty1, function (receiver) {
    return _get_original__l7ku1m(receiver);
  }, null);
}
function Composer_0(sb, json) {
  return json.ecx_1.ucy_1 ? new ComposerWithPrettyPrint(sb, json) : new Composer(sb);
}
function readIfAbsent($this, descriptor, index) {
  $this.xd1_1 = (!descriptor.nce(index) && descriptor.mce(index).ece());
  return $this.xd1_1;
}
function JsonElementMarker$readIfAbsent$ref($boundThis) {
  var l = function (p0, p1) {
    return readIfAbsent($boundThis, p0, p1);
  };
  l.callableName = 'readIfAbsent';
  return l;
}
function invalidTrailingComma(_this__u8e3s4, entity) {
  entity = entity === VOID ? 'object' : entity;
  _this__u8e3s4.ad2('Trailing comma before the end of JSON ' + entity, _this__u8e3s4.scx_1 - 1 | 0, "Trailing commas are non-complaint JSON and not allowed by default. Use 'allowTrailingCommas = true' in 'Json {}' builder to support them.");
}
function throwInvalidFloatingPointDecoded(_this__u8e3s4, result) {
  _this__u8e3s4.bd2('Unexpected special floating-point value ' + toString(result) + '. By default, ' + 'non-finite floating point values are prohibited because they do not conform JSON specification', VOID, "It is possible to deserialize them using 'JsonBuilder.allowSpecialFloatingPointValues = true'");
}
function InvalidKeyKindException(keyDescriptor) {
  return JsonEncodingException.id2("Value of type '" + keyDescriptor.ice() + "' can't be used in JSON as a key in the map. " + ("It should have either primitive or enum kind, but its kind is '" + keyDescriptor.oce().toString() + "'.\n") + "Use 'allowStructuredMapKeys = true' in 'Json {}' builder to convert such maps to [key1, value1, key2, value2,...] arrays.");
}
function JsonDecodingException_0(offset, message, input) {
  return JsonDecodingException_1(offset, message + '\nJSON input: ' + toString(minify(input, offset)));
}
function InvalidFloatingPointDecoded(value, key, output) {
  return JsonDecodingException_1(-1, unexpectedFpErrorMessage(value, key, output));
}
function UnknownKeyException(key, input) {
  return JsonDecodingException_1(-1, "Encountered an unknown key '" + key + "'.\n" + "Use 'ignoreUnknownKeys = true' in 'Json {}' builder to ignore unknown keys.\n" + ('Current input: ' + toString(minify(input))));
}
function InvalidFloatingPointEncoded(value, output) {
  return JsonEncodingException.id2('Unexpected special floating-point value ' + toString(value) + '. By default, ' + 'non-finite floating point values are prohibited because they do not conform JSON specification. ' + "It is possible to deserialize them using 'JsonBuilder.allowSpecialFloatingPointValues = true'\n" + ('Current output: ' + toString(minify(output))));
}
function unexpectedFpErrorMessage(value, key, output) {
  return 'Unexpected special floating-point value ' + toString(value) + ' with key ' + key + '. By default, ' + 'non-finite floating point values are prohibited because they do not conform JSON specification. ' + "It is possible to deserialize them using 'JsonBuilder.allowSpecialFloatingPointValues = true'\n" + ('Current output: ' + toString(minify(output)));
}
function JsonDecodingException_1(offset, message) {
  return JsonDecodingException.pd0(offset >= 0 ? 'Unexpected JSON token at offset ' + offset + ': ' + message : message);
}
function minify(_this__u8e3s4, offset) {
  offset = offset === VOID ? -1 : offset;
  if (charSequenceLength(_this__u8e3s4) < 200)
    return _this__u8e3s4;
  if (offset === -1) {
    var start = charSequenceLength(_this__u8e3s4) - 60 | 0;
    if (start <= 0)
      return _this__u8e3s4;
    // Inline function 'kotlin.text.substring' call
    var endIndex = charSequenceLength(_this__u8e3s4);
    return '.....' + toString(charSequenceSubSequence(_this__u8e3s4, start, endIndex));
  }
  var start_0 = offset - 30 | 0;
  var end = offset + 30 | 0;
  var prefix = start_0 <= 0 ? '' : '.....';
  var suffix = end >= charSequenceLength(_this__u8e3s4) ? '' : '.....';
  // Inline function 'kotlin.text.substring' call
  var startIndex = coerceAtLeast(start_0, 0);
  var endIndex_0 = coerceAtMost(end, charSequenceLength(_this__u8e3s4));
  return prefix + toString(charSequenceSubSequence(_this__u8e3s4, startIndex, endIndex_0)) + suffix;
}
function get_JsonDeserializationNamesKey() {
  _init_properties_JsonNamesMap_kt__cbbp0k();
  return JsonDeserializationNamesKey;
}
var JsonDeserializationNamesKey;
function get_JsonSerializationNamesKey() {
  _init_properties_JsonNamesMap_kt__cbbp0k();
  return JsonSerializationNamesKey;
}
var JsonSerializationNamesKey;
function getJsonNameIndex(_this__u8e3s4, json, name) {
  _init_properties_JsonNamesMap_kt__cbbp0k();
  if (decodeCaseInsensitive(json, _this__u8e3s4)) {
    // Inline function 'kotlin.text.lowercase' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$1 = name.toLowerCase();
    return getJsonNameIndexSlowPath(_this__u8e3s4, json, tmp$ret$1);
  }
  var strategy = namingStrategy(_this__u8e3s4, json);
  if (!(strategy == null))
    return getJsonNameIndexSlowPath(_this__u8e3s4, json, name);
  var index = _this__u8e3s4.kce(name);
  if (!(index === -3))
    return index;
  if (!json.ecx_1.bcz_1)
    return index;
  return getJsonNameIndexSlowPath(_this__u8e3s4, json, name);
}
function getJsonNameIndexOrThrow(_this__u8e3s4, json, name, suffix) {
  suffix = suffix === VOID ? '' : suffix;
  _init_properties_JsonNamesMap_kt__cbbp0k();
  var index = getJsonNameIndex(_this__u8e3s4, json, name);
  if (index === -3)
    throw SerializationException.icd(_this__u8e3s4.ice() + " does not contain element with name '" + name + "'" + suffix);
  return index;
}
function getJsonElementName(_this__u8e3s4, json, index) {
  _init_properties_JsonNamesMap_kt__cbbp0k();
  var strategy = namingStrategy(_this__u8e3s4, json);
  return strategy == null ? _this__u8e3s4.jce(index) : serializationNamesIndices(_this__u8e3s4, json, strategy)[index];
}
function namingStrategy(_this__u8e3s4, json) {
  _init_properties_JsonNamesMap_kt__cbbp0k();
  return equals(_this__u8e3s4.oce(), CLASS_getInstance()) ? json.ecx_1.ccz_1 : null;
}
function deserializationNamesMap(_this__u8e3s4, descriptor) {
  _init_properties_JsonNamesMap_kt__cbbp0k();
  var tmp = get_schemaCache(_this__u8e3s4);
  var tmp_0 = get_JsonDeserializationNamesKey();
  return tmp.qd2(descriptor, tmp_0, deserializationNamesMap$lambda(descriptor, _this__u8e3s4));
}
function decodeCaseInsensitive(_this__u8e3s4, descriptor) {
  _init_properties_JsonNamesMap_kt__cbbp0k();
  return _this__u8e3s4.ecx_1.dcz_1 && equals(descriptor.oce(), ENUM_getInstance());
}
function getJsonNameIndexSlowPath(_this__u8e3s4, json, name) {
  _init_properties_JsonNamesMap_kt__cbbp0k();
  var tmp0_elvis_lhs = deserializationNamesMap(json, _this__u8e3s4).h3(name);
  return tmp0_elvis_lhs == null ? -3 : tmp0_elvis_lhs;
}
function serializationNamesIndices(_this__u8e3s4, json, strategy) {
  _init_properties_JsonNamesMap_kt__cbbp0k();
  var tmp = get_schemaCache(json);
  var tmp_0 = get_JsonSerializationNamesKey();
  return tmp.qd2(_this__u8e3s4, tmp_0, serializationNamesIndices$lambda(_this__u8e3s4, strategy));
}
function buildDeserializationNamesMap(_this__u8e3s4, json) {
  _init_properties_JsonNamesMap_kt__cbbp0k();
  // Inline function 'kotlin.collections.mutableMapOf' call
  var builder = LinkedHashMap.rc();
  var useLowercaseEnums = decodeCaseInsensitive(json, _this__u8e3s4);
  var strategyForClasses = namingStrategy(_this__u8e3s4, json);
  var inductionVariable = 0;
  var last = _this__u8e3s4.qce();
  if (inductionVariable < last)
    do {
      var i = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'kotlin.collections.filterIsInstance' call
      // Inline function 'kotlin.collections.filterIsInstanceTo' call
      var this_0 = _this__u8e3s4.lce(i);
      var destination = ArrayList.i1();
      var tmp0_iterator = this_0.a1();
      while (tmp0_iterator.b1()) {
        var element = tmp0_iterator.c1();
        if (element instanceof JsonNames) {
          destination.h(element);
        }
      }
      var tmp9_safe_receiver = singleOrNull(destination);
      var tmp10_safe_receiver = tmp9_safe_receiver == null ? null : tmp9_safe_receiver.rd2_1;
      if (tmp10_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.collections.forEach' call
        var inductionVariable_0 = 0;
        var last_0 = tmp10_safe_receiver.length;
        while (inductionVariable_0 < last_0) {
          var element_0 = tmp10_safe_receiver[inductionVariable_0];
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          // Inline function 'kotlinx.serialization.json.internal.buildDeserializationNamesMap.<anonymous>' call
          var tmp;
          if (useLowercaseEnums) {
            // Inline function 'kotlin.text.lowercase' call
            // Inline function 'kotlin.js.asDynamic' call
            tmp = element_0.toLowerCase();
          } else {
            tmp = element_0;
          }
          buildDeserializationNamesMap$putOrThrow(builder, _this__u8e3s4, tmp, i);
        }
      }
      var tmp_0;
      if (useLowercaseEnums) {
        // Inline function 'kotlin.text.lowercase' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp_0 = _this__u8e3s4.jce(i).toLowerCase();
      } else if (!(strategyForClasses == null)) {
        tmp_0 = strategyForClasses.sd2(_this__u8e3s4, i, _this__u8e3s4.jce(i));
      } else {
        tmp_0 = null;
      }
      var nameToPut = tmp_0;
      if (nameToPut == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        buildDeserializationNamesMap$putOrThrow(builder, _this__u8e3s4, nameToPut, i);
      }
    }
     while (inductionVariable < last);
  // Inline function 'kotlin.collections.ifEmpty' call
  // Inline function 'kotlin.contracts.contract' call
  var tmp_1;
  if (builder.g1()) {
    // Inline function 'kotlinx.serialization.json.internal.buildDeserializationNamesMap.<anonymous>' call
    tmp_1 = emptyMap();
  } else {
    tmp_1 = builder;
  }
  return tmp_1;
}
function buildDeserializationNamesMap$putOrThrow(_this__u8e3s4, $this_buildDeserializationNamesMap, name, index) {
  var entity = equals($this_buildDeserializationNamesMap.oce(), ENUM_getInstance()) ? 'enum value' : 'property';
  // Inline function 'kotlin.collections.contains' call
  // Inline function 'kotlin.collections.containsKey' call
  if ((isInterface(_this__u8e3s4, KtMap) ? _this__u8e3s4 : THROW_CCE()).f3(name)) {
    throw JsonException.od2("The suggested name '" + name + "' for " + entity + ' ' + $this_buildDeserializationNamesMap.jce(index) + ' is already one of the names for ' + entity + ' ' + ($this_buildDeserializationNamesMap.jce(getValue(_this__u8e3s4, name)) + ' in ' + toString($this_buildDeserializationNamesMap)));
  }
  // Inline function 'kotlin.collections.set' call
  _this__u8e3s4.j3(name, index);
}
function deserializationNamesMap$lambda($descriptor, $this_deserializationNamesMap) {
  return function () {
    return buildDeserializationNamesMap($descriptor, $this_deserializationNamesMap);
  };
}
function serializationNamesIndices$lambda($this_serializationNamesIndices, $strategy) {
  return function () {
    var tmp = 0;
    var tmp_0 = $this_serializationNamesIndices.qce();
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_1 = fillArrayVal(Array(tmp_0), null);
    while (tmp < tmp_0) {
      var tmp_2 = tmp;
      var baseName = $this_serializationNamesIndices.jce(tmp_2);
      tmp_1[tmp_2] = $strategy.sd2($this_serializationNamesIndices, tmp_2, baseName);
      tmp = tmp + 1 | 0;
    }
    return tmp_1;
  };
}
var properties_initialized_JsonNamesMap_kt_ljpf42;
function _init_properties_JsonNamesMap_kt__cbbp0k() {
  if (!properties_initialized_JsonNamesMap_kt_ljpf42) {
    properties_initialized_JsonNamesMap_kt_ljpf42 = true;
    JsonDeserializationNamesKey = new Key();
    JsonSerializationNamesKey = new Key();
  }
}
var Tombstone_instance;
function Tombstone_getInstance() {
  return Tombstone_instance;
}
function resize($this) {
  var newSize = imul($this.vd2_1, 2);
  $this.td2_1 = copyOf($this.td2_1, newSize);
  $this.ud2_1 = copyOf_0($this.ud2_1, newSize);
}
function encodeByWriter(json, writer, serializer, value) {
  var tmp = WriteMode_OBJ_getInstance();
  // Inline function 'kotlin.arrayOfNulls' call
  var size = get_entries().e1();
  var tmp$ret$0 = fillArrayVal(Array(size), null);
  var encoder = StreamingJsonEncoder.ld3(writer, json, tmp, tmp$ret$0);
  encoder.ych(serializer, value);
}
function *_generator_invoke__zhh2q8($this, $this$DeepRecursiveFunction, it, $completion) {
  var tmp14_subject = $this.qd3_1.md3_1.rd3();
  var tmp;
  if (tmp14_subject === 1) {
    tmp = readValue($this.qd3_1, true);
  } else if (tmp14_subject === 0) {
    tmp = readValue($this.qd3_1, false);
  } else if (tmp14_subject === 6) {
    var tmp_0 = readObject_0($this$DeepRecursiveFunction, $this.qd3_1, $completion);
    if (tmp_0 === get_COROUTINE_SUSPENDED())
      tmp_0 = yield tmp_0;
    tmp = tmp_0;
  } else if (tmp14_subject === 8) {
    tmp = readArray($this.qd3_1);
  } else {
    $this.qd3_1.md3_1.bd2("Can't begin reading element, unexpected token");
  }
  return tmp;
}
function readObject($this) {
  // Inline function 'kotlinx.serialization.json.internal.JsonTreeReader.readObjectImpl' call
  var lastToken = $this.md3_1.sd3(6);
  if ($this.md3_1.rd3() === 4) {
    $this.md3_1.bd2('Unexpected leading comma');
  }
  // Inline function 'kotlin.collections.linkedMapOf' call
  var result = LinkedHashMap.rc();
  $l$loop: while ($this.md3_1.td3()) {
    var key = $this.nd3_1 ? $this.md3_1.vd3() : $this.md3_1.ud3();
    $this.md3_1.sd3(5);
    // Inline function 'kotlinx.serialization.json.internal.JsonTreeReader.readObject.<anonymous>' call
    var element = $this.w1x();
    // Inline function 'kotlin.collections.set' call
    result.j3(key, element);
    lastToken = $this.md3_1.wd3();
    var tmp13_subject = lastToken;
    if (tmp13_subject !== 4)
      if (tmp13_subject === 7)
        break $l$loop;
      else {
        $this.md3_1.bd2('Expected end of the object or comma');
      }
  }
  if (lastToken === 6) {
    $this.md3_1.sd3(7);
  } else if (lastToken === 4) {
    if (!$this.od3_1) {
      invalidTrailingComma($this.md3_1);
    }
    $this.md3_1.sd3(7);
  }
  return new JsonObject(result);
}
function *_generator_readObject__361wel(_this__u8e3s4, $this, $completion) {
  // Inline function 'kotlinx.serialization.json.internal.JsonTreeReader.readObjectImpl' call
  var lastToken = $this.md3_1.sd3(6);
  if ($this.md3_1.rd3() === 4) {
    $this.md3_1.bd2('Unexpected leading comma');
  }
  // Inline function 'kotlin.collections.linkedMapOf' call
  var result = LinkedHashMap.rc();
  $l$loop: while ($this.md3_1.td3()) {
    var key = $this.nd3_1 ? $this.md3_1.vd3() : $this.md3_1.ud3();
    $this.md3_1.sd3(5);
    // Inline function 'kotlinx.serialization.json.internal.JsonTreeReader.readObject.<anonymous>' call
    var tmp = _this__u8e3s4.ns(Unit_instance, $completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
    var element = tmp;
    // Inline function 'kotlin.collections.set' call
    result.j3(key, element);
    lastToken = $this.md3_1.wd3();
    var tmp13_subject = lastToken;
    if (tmp13_subject !== 4)
      if (tmp13_subject === 7)
        break $l$loop;
      else {
        $this.md3_1.bd2('Expected end of the object or comma');
      }
  }
  if (lastToken === 6) {
    $this.md3_1.sd3(7);
  } else if (lastToken === 4) {
    if (!$this.od3_1) {
      invalidTrailingComma($this.md3_1);
    }
    $this.md3_1.sd3(7);
  }
  return new JsonObject(result);
}
function readObject_0(_this__u8e3s4, $this, $completion) {
  return suspendOrReturn(/*#__NOINLINE__*/_generator_readObject__361wel.bind(VOID, _this__u8e3s4, $this), $completion);
}
function readArray($this) {
  var lastToken = $this.md3_1.wd3();
  if ($this.md3_1.rd3() === 4) {
    $this.md3_1.bd2('Unexpected leading comma');
  }
  // Inline function 'kotlin.collections.arrayListOf' call
  var result = ArrayList.i1();
  while ($this.md3_1.td3()) {
    var element = $this.w1x();
    result.h(element);
    lastToken = $this.md3_1.wd3();
    if (!(lastToken === 4)) {
      // Inline function 'kotlinx.serialization.json.internal.AbstractJsonLexer.require' call
      var this_0 = $this.md3_1;
      var condition = lastToken === 9;
      var position = this_0.scx_1;
      if (!condition) {
        // Inline function 'kotlinx.serialization.json.internal.JsonTreeReader.readArray.<anonymous>' call
        var tmp$ret$1 = 'Expected end of the array or comma';
        this_0.bd2(tmp$ret$1, position);
      }
    }
  }
  if (lastToken === 8) {
    $this.md3_1.sd3(9);
  } else if (lastToken === 4) {
    if (!$this.od3_1) {
      invalidTrailingComma($this.md3_1, 'array');
    }
    $this.md3_1.sd3(9);
  }
  return new JsonArray(result);
}
function readValue($this, isString) {
  var tmp;
  if ($this.nd3_1 || !isString) {
    tmp = $this.md3_1.vd3();
  } else {
    tmp = $this.md3_1.ud3();
  }
  var string = tmp;
  if (!isString && string === 'null')
    return JsonNull_getInstance();
  return new JsonLiteral(string, isString);
}
function readDeepRecursive($this) {
  return invoke(new DeepRecursiveFunction(JsonTreeReader$readDeepRecursive$slambda_0($this)), Unit_instance);
}
function JsonTreeReader$readDeepRecursive$slambda_0(this$0) {
  var i = new JsonTreeReader$readDeepRecursive$slambda(this$0);
  var l = function ($this$DeepRecursiveFunction, it, $completion) {
    return i.xd3($this$DeepRecursiveFunction, it, $completion);
  };
  l.$arity = 2;
  return l;
}
function classDiscriminator(_this__u8e3s4, json) {
  var _iterator__ex2g4s = _this__u8e3s4.rce().a1();
  while (_iterator__ex2g4s.b1()) {
    var annotation = _iterator__ex2g4s.c1();
    if (annotation instanceof JsonClassDiscriminator)
      return annotation.yd3_1;
  }
  return json.ecx_1.zcy_1;
}
function validateIfSealed(serializer, actualSerializer, classDiscriminator) {
  if (!(serializer instanceof SealedClassSerializer))
    return Unit_instance;
  if (jsonCachedSerialNames(actualSerializer.jcc()).z2(classDiscriminator)) {
    var baseName = serializer.jcc().ice();
    var actualName = actualSerializer.jcc().ice();
    // Inline function 'kotlin.error' call
    var message = "Sealed class '" + actualName + "' cannot be serialized as base class '" + baseName + "' because" + (" it has property name that conflicts with JSON class discriminator '" + classDiscriminator + "'. ") + 'You can either change class discriminator in JsonConfiguration, ' + 'rename property with @SerialName annotation or fall back to array polymorphism';
    throw IllegalStateException.l5(toString(message));
  }
}
function checkKind(kind) {
  if (kind instanceof ENUM) {
    // Inline function 'kotlin.error' call
    var message = "Enums cannot be serialized polymorphically with 'type' parameter. You can use 'JsonBuilder.useArrayPolymorphism' instead";
    throw IllegalStateException.l5(toString(message));
  }
  if (kind instanceof PrimitiveKind) {
    // Inline function 'kotlin.error' call
    var message_0 = "Primitives cannot be serialized polymorphically with 'type' parameter. You can use 'JsonBuilder.useArrayPolymorphism' instead";
    throw IllegalStateException.l5(toString(message_0));
  }
  if (kind instanceof PolymorphicKind) {
    // Inline function 'kotlin.error' call
    var message_1 = 'Actual serializer for polymorphic cannot be polymorphic itself';
    throw IllegalStateException.l5(toString(message_1));
  }
}
function validateIfSealed$accessor$1rk9rdt(serializer, actualSerializer, classDiscriminator) {
  return validateIfSealed(serializer, actualSerializer, classDiscriminator);
}
function checkKind_0($this, descriptor, actualClass) {
  var kind = descriptor.oce();
  var tmp;
  if (kind instanceof PolymorphicKind) {
    tmp = true;
  } else {
    tmp = equals(kind, CONTEXTUAL_getInstance());
  }
  if (tmp) {
    throw IllegalArgumentException.l('Serializer for ' + actualClass.nf() + " can't be registered as a subclass for polymorphic serialization " + ('because its kind ' + kind.toString() + ' is not concrete. To work with multiple hierarchies, register it as a base class.'));
  }
  if ($this.zd3_1)
    return Unit_instance;
  var tmp_0;
  var tmp_1;
  if (equals(kind, LIST_getInstance()) || equals(kind, MAP_getInstance())) {
    tmp_1 = true;
  } else {
    tmp_1 = kind instanceof PrimitiveKind;
  }
  if (tmp_1) {
    tmp_0 = true;
  } else {
    tmp_0 = kind instanceof ENUM;
  }
  if (tmp_0) {
    throw IllegalArgumentException.l('Serializer for ' + actualClass.nf() + ' of kind ' + kind.toString() + ' cannot be serialized polymorphically with class discriminator.');
  }
}
function checkDiscriminatorCollisions($this, descriptor, actualClass) {
  var inductionVariable = 0;
  var last = descriptor.qce();
  if (inductionVariable < last)
    do {
      var i = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var name = descriptor.jce(i);
      if (name === $this.ad4_1) {
        throw IllegalArgumentException.l('Polymorphic serializer for ' + toString(actualClass) + " has property '" + name + "' that conflicts " + 'with JSON class discriminator. You can either change class discriminator in JsonConfiguration, ' + 'rename property with @SerialName annotation ' + 'or fall back to array polymorphism');
      }
    }
     while (inductionVariable < last);
}
function trySkip(_this__u8e3s4, $this, unknownKey) {
  if (_this__u8e3s4 == null)
    return false;
  if (_this__u8e3s4.dd4_1 === unknownKey) {
    _this__u8e3s4.dd4_1 = null;
    return true;
  }
  return false;
}
function skipLeftoverElements($this, descriptor) {
  while (!($this.wcg(descriptor) === -1)) {
  }
}
function checkLeadingComma($this) {
  if ($this.mcx_1.rd3() === 4) {
    $this.mcx_1.bd2('Unexpected leading comma');
  }
}
function decodeMapIndex($this) {
  var hasComma = false;
  var decodingKey = !(($this.ocx_1 % 2 | 0) === 0);
  if (decodingKey) {
    if (!($this.ocx_1 === -1)) {
      hasComma = $this.mcx_1.fd4();
    }
  } else {
    $this.mcx_1.ed4(_Char___init__impl__6a9atx(58));
  }
  var tmp;
  if ($this.mcx_1.td3()) {
    if (decodingKey) {
      if ($this.ocx_1 === -1) {
        // Inline function 'kotlinx.serialization.json.internal.AbstractJsonLexer.require' call
        var this_0 = $this.mcx_1;
        var condition = !hasComma;
        var position = this_0.scx_1;
        if (!condition) {
          // Inline function 'kotlinx.serialization.json.internal.StreamingJsonDecoder.decodeMapIndex.<anonymous>' call
          var tmp$ret$0 = 'Unexpected leading comma';
          this_0.bd2(tmp$ret$0, position);
        }
      } else {
        // Inline function 'kotlinx.serialization.json.internal.AbstractJsonLexer.require' call
        var this_1 = $this.mcx_1;
        var condition_0 = hasComma;
        var position_0 = this_1.scx_1;
        if (!condition_0) {
          // Inline function 'kotlinx.serialization.json.internal.StreamingJsonDecoder.decodeMapIndex.<anonymous>' call
          var tmp$ret$1 = 'Expected comma after the key-value pair';
          this_1.bd2(tmp$ret$1, position_0);
        }
      }
    }
    $this.ocx_1 = $this.ocx_1 + 1 | 0;
    tmp = $this.ocx_1;
  } else {
    if (hasComma && !$this.kcx_1.ecx_1.ecz_1) {
      invalidTrailingComma($this.mcx_1);
    }
    tmp = -1;
  }
  return tmp;
}
function coerceInputValue($this, descriptor, index) {
  var tmp$ret$1;
  $l$block_2: {
    // Inline function 'kotlinx.serialization.json.internal.tryCoerceValue' call
    var this_0 = $this.kcx_1;
    var isOptional = descriptor.nce(index);
    var elementDescriptor = descriptor.mce(index);
    var tmp;
    if (isOptional && !elementDescriptor.ece()) {
      // Inline function 'kotlinx.serialization.json.internal.StreamingJsonDecoder.coerceInputValue.<anonymous>' call
      tmp = $this.mcx_1.gd4(true);
    } else {
      tmp = false;
    }
    if (tmp) {
      tmp$ret$1 = true;
      break $l$block_2;
    }
    if (equals(elementDescriptor.oce(), ENUM_getInstance())) {
      var tmp_0;
      if (elementDescriptor.ece()) {
        // Inline function 'kotlinx.serialization.json.internal.StreamingJsonDecoder.coerceInputValue.<anonymous>' call
        tmp_0 = $this.mcx_1.gd4(false);
      } else {
        tmp_0 = false;
      }
      if (tmp_0) {
        tmp$ret$1 = false;
        break $l$block_2;
      }
      // Inline function 'kotlinx.serialization.json.internal.StreamingJsonDecoder.coerceInputValue.<anonymous>' call
      var tmp0_elvis_lhs = $this.mcx_1.hd4($this.qcx_1.scy_1);
      var tmp_1;
      if (tmp0_elvis_lhs == null) {
        tmp$ret$1 = false;
        break $l$block_2;
      } else {
        tmp_1 = tmp0_elvis_lhs;
      }
      var enumValue = tmp_1;
      var enumIndex = getJsonNameIndex(elementDescriptor, this_0, enumValue);
      var coerceToNull = !this_0.ecx_1.vcy_1 && elementDescriptor.ece();
      if (enumIndex === -3 && (isOptional || coerceToNull)) {
        // Inline function 'kotlinx.serialization.json.internal.StreamingJsonDecoder.coerceInputValue.<anonymous>' call
        $this.mcx_1.ud3();
        tmp$ret$1 = true;
        break $l$block_2;
      }
    }
    tmp$ret$1 = false;
  }
  return tmp$ret$1;
}
function decodeObjectIndex($this, descriptor) {
  var hasComma = $this.mcx_1.fd4();
  while ($this.mcx_1.td3()) {
    hasComma = false;
    var key = decodeStringKey($this);
    $this.mcx_1.ed4(_Char___init__impl__6a9atx(58));
    var index = getJsonNameIndex(descriptor, $this.kcx_1, key);
    var tmp;
    if (!(index === -3)) {
      var tmp_0;
      if ($this.qcx_1.xcy_1 && coerceInputValue($this, descriptor, index)) {
        hasComma = $this.mcx_1.fd4();
        tmp_0 = false;
      } else {
        var tmp23_safe_receiver = $this.rcx_1;
        if (tmp23_safe_receiver == null)
          null;
        else {
          tmp23_safe_receiver.yd1(index);
        }
        return index;
      }
      tmp = tmp_0;
    } else {
      tmp = true;
    }
    var isUnknown = tmp;
    if (isUnknown) {
      hasComma = handleUnknown($this, key);
    }
  }
  if (hasComma && !$this.kcx_1.ecx_1.ecz_1) {
    invalidTrailingComma($this.mcx_1);
  }
  var tmp24_safe_receiver = $this.rcx_1;
  var tmp0_elvis_lhs = tmp24_safe_receiver == null ? null : tmp24_safe_receiver.zd1();
  return tmp0_elvis_lhs == null ? -1 : tmp0_elvis_lhs;
}
function handleUnknown($this, key) {
  if ($this.qcx_1.rcy_1 || trySkip($this.pcx_1, $this, key)) {
    $this.mcx_1.jd4($this.qcx_1.scy_1);
  } else {
    $this.mcx_1.id4(key);
  }
  return $this.mcx_1.fd4();
}
function decodeListIndex($this) {
  var hasComma = $this.mcx_1.fd4();
  var tmp;
  if ($this.mcx_1.td3()) {
    if (!($this.ocx_1 === -1) && !hasComma) {
      $this.mcx_1.bd2('Expected end of the array or comma');
    }
    $this.ocx_1 = $this.ocx_1 + 1 | 0;
    tmp = $this.ocx_1;
  } else {
    if (hasComma && !$this.kcx_1.ecx_1.ecz_1) {
      invalidTrailingComma($this.mcx_1, 'array');
    }
    tmp = -1;
  }
  return tmp;
}
function decodeStringKey($this) {
  var tmp;
  if ($this.qcx_1.scy_1) {
    tmp = $this.mcx_1.ld4();
  } else {
    tmp = $this.mcx_1.kd4();
  }
  return tmp;
}
function get_unsignedNumberDescriptors() {
  _init_properties_StreamingJsonEncoder_kt__pn1bsi();
  return unsignedNumberDescriptors;
}
var unsignedNumberDescriptors;
function encodeTypeInfo($this, discriminator, serialName) {
  $this.cd3_1.vd0();
  $this.kch(discriminator);
  $this.cd3_1.yd0(_Char___init__impl__6a9atx(58));
  $this.cd3_1.xd0();
  $this.kch(serialName);
}
function get_isUnsignedNumber(_this__u8e3s4) {
  _init_properties_StreamingJsonEncoder_kt__pn1bsi();
  return _this__u8e3s4.pce() && get_unsignedNumberDescriptors().z2(_this__u8e3s4);
}
function get_isUnquotedLiteral(_this__u8e3s4) {
  _init_properties_StreamingJsonEncoder_kt__pn1bsi();
  return _this__u8e3s4.pce() && equals(_this__u8e3s4, get_jsonUnquotedLiteralDescriptor());
}
var properties_initialized_StreamingJsonEncoder_kt_6ifwwk;
function _init_properties_StreamingJsonEncoder_kt__pn1bsi() {
  if (!properties_initialized_StreamingJsonEncoder_kt_6ifwwk) {
    properties_initialized_StreamingJsonEncoder_kt_6ifwwk = true;
    unsignedNumberDescriptors = setOf([serializer_1(Companion_getInstance_0()).jcc(), serializer_0(Companion_getInstance()).jcc(), serializer_2(Companion_getInstance_1()).jcc(), serializer_3(Companion_getInstance_2()).jcc()]);
  }
}
function get_ESCAPE_STRINGS() {
  _init_properties_StringOps_kt__fcy1db();
  return ESCAPE_STRINGS;
}
var ESCAPE_STRINGS;
var ESCAPE_MARKERS;
function toHexChar(i) {
  _init_properties_StringOps_kt__fcy1db();
  var d = i & 15;
  var tmp;
  if (d < 10) {
    // Inline function 'kotlin.code' call
    var this_0 = _Char___init__impl__6a9atx(48);
    var tmp$ret$0 = Char__toInt_impl_vasixd(this_0);
    tmp = numberToChar(d + tmp$ret$0 | 0);
  } else {
    var tmp_0 = d - 10 | 0;
    // Inline function 'kotlin.code' call
    var this_1 = _Char___init__impl__6a9atx(97);
    var tmp$ret$1 = Char__toInt_impl_vasixd(this_1);
    tmp = numberToChar(tmp_0 + tmp$ret$1 | 0);
  }
  return tmp;
}
function printQuoted(_this__u8e3s4, value) {
  _init_properties_StringOps_kt__fcy1db();
  _this__u8e3s4.fc(_Char___init__impl__6a9atx(34));
  var lastPos = 0;
  var inductionVariable = 0;
  var last = charSequenceLength(value) - 1 | 0;
  if (inductionVariable <= last)
    do {
      var i = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'kotlin.code' call
      var this_0 = charSequenceGet(value, i);
      var c = Char__toInt_impl_vasixd(this_0);
      if (c < get_ESCAPE_STRINGS().length && !(get_ESCAPE_STRINGS()[c] == null)) {
        _this__u8e3s4.dh(value, lastPos, i);
        _this__u8e3s4.ec(get_ESCAPE_STRINGS()[c]);
        lastPos = i + 1 | 0;
      }
    }
     while (inductionVariable <= last);
  if (!(lastPos === 0))
    _this__u8e3s4.dh(value, lastPos, value.length);
  else
    _this__u8e3s4.ec(value);
  _this__u8e3s4.fc(_Char___init__impl__6a9atx(34));
}
function toBooleanStrictOrNull_0(_this__u8e3s4) {
  _init_properties_StringOps_kt__fcy1db();
  return equals_0(_this__u8e3s4, 'true', true) ? true : equals_0(_this__u8e3s4, 'false', true) ? false : null;
}
var properties_initialized_StringOps_kt_wzaea7;
function _init_properties_StringOps_kt__fcy1db() {
  if (!properties_initialized_StringOps_kt_wzaea7) {
    properties_initialized_StringOps_kt_wzaea7 = true;
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.arrayOfNulls' call
    var this_0 = fillArrayVal(Array(93), null);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlinx.serialization.json.internal.ESCAPE_STRINGS.<anonymous>' call
    var inductionVariable = 0;
    if (inductionVariable <= 31)
      do {
        var c = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var c1 = toHexChar(c >> 12);
        var c2 = toHexChar(c >> 8);
        var c3 = toHexChar(c >> 4);
        var c4 = toHexChar(c);
        this_0[c] = '\\u' + toString_1(c1) + toString_1(c2) + toString_1(c3) + toString_1(c4);
      }
       while (inductionVariable <= 31);
    // Inline function 'kotlin.code' call
    var this_1 = _Char___init__impl__6a9atx(34);
    this_0[Char__toInt_impl_vasixd(this_1)] = '\\"';
    // Inline function 'kotlin.code' call
    var this_2 = _Char___init__impl__6a9atx(92);
    this_0[Char__toInt_impl_vasixd(this_2)] = '\\\\';
    // Inline function 'kotlin.code' call
    var this_3 = _Char___init__impl__6a9atx(9);
    this_0[Char__toInt_impl_vasixd(this_3)] = '\\t';
    // Inline function 'kotlin.code' call
    var this_4 = _Char___init__impl__6a9atx(8);
    this_0[Char__toInt_impl_vasixd(this_4)] = '\\b';
    // Inline function 'kotlin.code' call
    var this_5 = _Char___init__impl__6a9atx(10);
    this_0[Char__toInt_impl_vasixd(this_5)] = '\\n';
    // Inline function 'kotlin.code' call
    var this_6 = _Char___init__impl__6a9atx(13);
    this_0[Char__toInt_impl_vasixd(this_6)] = '\\r';
    this_0[12] = '\\f';
    ESCAPE_STRINGS = this_0;
    // Inline function 'kotlin.apply' call
    var this_7 = new Int8Array(93);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlinx.serialization.json.internal.ESCAPE_MARKERS.<anonymous>' call
    var inductionVariable_0 = 0;
    if (inductionVariable_0 <= 31)
      do {
        var c_0 = inductionVariable_0;
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        this_7[c_0] = 1;
      }
       while (inductionVariable_0 <= 31);
    // Inline function 'kotlin.code' call
    var this_8 = _Char___init__impl__6a9atx(34);
    this_7[Char__toInt_impl_vasixd(this_8)] = 34;
    // Inline function 'kotlin.code' call
    var this_9 = _Char___init__impl__6a9atx(92);
    this_7[Char__toInt_impl_vasixd(this_9)] = 92;
    // Inline function 'kotlin.code' call
    var this_10 = _Char___init__impl__6a9atx(9);
    this_7[Char__toInt_impl_vasixd(this_10)] = 116;
    // Inline function 'kotlin.code' call
    var this_11 = _Char___init__impl__6a9atx(8);
    this_7[Char__toInt_impl_vasixd(this_11)] = 98;
    // Inline function 'kotlin.code' call
    var this_12 = _Char___init__impl__6a9atx(10);
    this_7[Char__toInt_impl_vasixd(this_12)] = 110;
    // Inline function 'kotlin.code' call
    var this_13 = _Char___init__impl__6a9atx(13);
    this_7[Char__toInt_impl_vasixd(this_13)] = 114;
    this_7[12] = 102;
    ESCAPE_MARKERS = this_7;
  }
}
function unparsedPrimitive($this, literal, primitive, tag) {
  var type = startsWith(primitive, 'i') ? 'an ' + primitive : 'a ' + primitive;
  throw JsonDecodingException_0(-1, "Failed to parse literal '" + literal.toString() + "' as " + type + ' value at element: ' + $this.cd5(tag), toString($this.dd5()));
}
function coerceInputValue_0($this, descriptor, index, tag) {
  var tmp$ret$1;
  $l$block_2: {
    // Inline function 'kotlinx.serialization.json.internal.tryCoerceValue' call
    var this_0 = $this.hcz();
    var isOptional = descriptor.nce(index);
    var elementDescriptor = descriptor.mce(index);
    var tmp;
    if (isOptional && !elementDescriptor.ece()) {
      // Inline function 'kotlinx.serialization.json.internal.JsonTreeDecoder.coerceInputValue.<anonymous>' call
      var tmp_0 = $this.ed5(tag);
      tmp = tmp_0 instanceof JsonNull;
    } else {
      tmp = false;
    }
    if (tmp) {
      tmp$ret$1 = true;
      break $l$block_2;
    }
    if (equals(elementDescriptor.oce(), ENUM_getInstance())) {
      var tmp_1;
      if (elementDescriptor.ece()) {
        // Inline function 'kotlinx.serialization.json.internal.JsonTreeDecoder.coerceInputValue.<anonymous>' call
        var tmp_2 = $this.ed5(tag);
        tmp_1 = tmp_2 instanceof JsonNull;
      } else {
        tmp_1 = false;
      }
      if (tmp_1) {
        tmp$ret$1 = false;
        break $l$block_2;
      }
      // Inline function 'kotlinx.serialization.json.internal.JsonTreeDecoder.coerceInputValue.<anonymous>' call
      var tmp_3 = $this.ed5(tag);
      var tmp30_safe_receiver = tmp_3 instanceof JsonPrimitive ? tmp_3 : null;
      var tmp0_elvis_lhs = tmp30_safe_receiver == null ? null : get_contentOrNull(tmp30_safe_receiver);
      var tmp_4;
      if (tmp0_elvis_lhs == null) {
        tmp$ret$1 = false;
        break $l$block_2;
      } else {
        tmp_4 = tmp0_elvis_lhs;
      }
      var enumValue = tmp_4;
      var enumIndex = getJsonNameIndex(elementDescriptor, this_0, enumValue);
      var coerceToNull = !this_0.ecx_1.vcy_1 && elementDescriptor.ece();
      if (enumIndex === -3 && (isOptional || coerceToNull)) {
        // Inline function 'kotlinx.serialization.json.internal.tryCoerceValue.<anonymous>' call
        tmp$ret$1 = true;
        break $l$block_2;
      }
    }
    tmp$ret$1 = false;
  }
  return tmp$ret$1;
}
function absenceIsNull($this, descriptor, index) {
  $this.ad6_1 = (!$this.hcz().ecx_1.vcy_1 && !descriptor.nce(index) && descriptor.mce(index).ece());
  return $this.ad6_1;
}
function readPolymorphicJson(_this__u8e3s4, discriminator, element, deserializer) {
  return (new JsonTreeDecoder(_this__u8e3s4, element, discriminator, deserializer.jcc())).ecg(deserializer);
}
var WriteMode_OBJ_instance;
var WriteMode_LIST_instance;
var WriteMode_MAP_instance;
var WriteMode_POLY_OBJ_instance;
function values() {
  return [WriteMode_OBJ_getInstance(), WriteMode_LIST_getInstance(), WriteMode_MAP_getInstance(), WriteMode_POLY_OBJ_getInstance()];
}
function get_entries() {
  if ($ENTRIES == null)
    $ENTRIES = enumEntries(values());
  return $ENTRIES;
}
var WriteMode_entriesInitialized;
function WriteMode_initEntries() {
  if (WriteMode_entriesInitialized)
    return Unit_instance;
  WriteMode_entriesInitialized = true;
  WriteMode_OBJ_instance = new WriteMode('OBJ', 0, _Char___init__impl__6a9atx(123), _Char___init__impl__6a9atx(125));
  WriteMode_LIST_instance = new WriteMode('LIST', 1, _Char___init__impl__6a9atx(91), _Char___init__impl__6a9atx(93));
  WriteMode_MAP_instance = new WriteMode('MAP', 2, _Char___init__impl__6a9atx(123), _Char___init__impl__6a9atx(125));
  WriteMode_POLY_OBJ_instance = new WriteMode('POLY_OBJ', 3, _Char___init__impl__6a9atx(91), _Char___init__impl__6a9atx(93));
}
var $ENTRIES;
function switchMode(_this__u8e3s4, desc) {
  var tmp36_subject = desc.oce();
  var tmp;
  if (tmp36_subject instanceof PolymorphicKind) {
    tmp = WriteMode_POLY_OBJ_getInstance();
  } else {
    if (equals(tmp36_subject, LIST_getInstance())) {
      tmp = WriteMode_LIST_getInstance();
    } else {
      if (equals(tmp36_subject, MAP_getInstance())) {
        // Inline function 'kotlinx.serialization.json.internal.selectMapMode' call
        var keyDescriptor = carrierDescriptor(desc.mce(0), _this__u8e3s4.ucg());
        var keyKind = keyDescriptor.oce();
        var tmp_0;
        var tmp_1;
        if (keyKind instanceof PrimitiveKind) {
          tmp_1 = true;
        } else {
          tmp_1 = equals(keyKind, ENUM_getInstance());
        }
        if (tmp_1) {
          // Inline function 'kotlinx.serialization.json.internal.switchMode.<anonymous>' call
          tmp_0 = WriteMode_MAP_getInstance();
        } else {
          if (_this__u8e3s4.ecx_1.tcy_1) {
            // Inline function 'kotlinx.serialization.json.internal.switchMode.<anonymous>' call
            tmp_0 = WriteMode_LIST_getInstance();
          } else {
            throw InvalidKeyKindException(keyDescriptor);
          }
        }
        tmp = tmp_0;
      } else {
        tmp = WriteMode_OBJ_getInstance();
      }
    }
  }
  return tmp;
}
function carrierDescriptor(_this__u8e3s4, module_0) {
  var tmp;
  if (equals(_this__u8e3s4.oce(), CONTEXTUAL_getInstance())) {
    var tmp37_safe_receiver = getContextualDescriptor(module_0, _this__u8e3s4);
    var tmp0_elvis_lhs = tmp37_safe_receiver == null ? null : carrierDescriptor(tmp37_safe_receiver, module_0);
    tmp = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  } else if (_this__u8e3s4.pce()) {
    tmp = carrierDescriptor(_this__u8e3s4.mce(0), module_0);
  } else {
    tmp = _this__u8e3s4;
  }
  return tmp;
}
function WriteMode_OBJ_getInstance() {
  WriteMode_initEntries();
  return WriteMode_OBJ_instance;
}
function WriteMode_LIST_getInstance() {
  WriteMode_initEntries();
  return WriteMode_LIST_instance;
}
function WriteMode_MAP_getInstance() {
  WriteMode_initEntries();
  return WriteMode_MAP_instance;
}
function WriteMode_POLY_OBJ_getInstance() {
  WriteMode_initEntries();
  return WriteMode_POLY_OBJ_instance;
}
function appendEscape($this, lastPosition, current) {
  $this.fd7(lastPosition, current);
  return appendEsc($this, current + 1 | 0);
}
function decodedString($this, lastPosition, currentPosition) {
  $this.fd7(lastPosition, currentPosition);
  var result = $this.vcx_1.toString();
  $this.vcx_1.lh(0);
  return result;
}
function takePeeked($this) {
  // Inline function 'kotlin.also' call
  var this_0 = ensureNotNull($this.ucx_1);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'kotlinx.serialization.json.internal.AbstractJsonLexer.takePeeked.<anonymous>' call
  $this.ucx_1 = null;
  return this_0;
}
function wasUnquotedString($this) {
  return !(charSequenceGet($this.gd7(), $this.scx_1 - 1 | 0) === _Char___init__impl__6a9atx(34));
}
function appendEsc($this, startPosition) {
  var currentPosition = startPosition;
  currentPosition = $this.hd7(currentPosition);
  if (currentPosition === -1) {
    $this.bd2('Expected escape sequence to continue, got EOF');
  }
  var tmp = $this.gd7();
  var _unary__edvuaz = currentPosition;
  currentPosition = _unary__edvuaz + 1 | 0;
  var currentChar = charSequenceGet(tmp, _unary__edvuaz);
  if (currentChar === _Char___init__impl__6a9atx(117)) {
    return appendHex($this, $this.gd7(), currentPosition);
  }
  // Inline function 'kotlin.code' call
  var tmp$ret$0 = Char__toInt_impl_vasixd(currentChar);
  var c = escapeToChar(tmp$ret$0);
  if (c === _Char___init__impl__6a9atx(0)) {
    $this.bd2("Invalid escaped char '" + toString_1(currentChar) + "'");
  }
  $this.vcx_1.fc(c);
  return currentPosition;
}
function appendHex($this, source, startPos) {
  if ((startPos + 4 | 0) >= charSequenceLength(source)) {
    $this.scx_1 = startPos;
    $this.id7();
    if (($this.scx_1 + 4 | 0) >= charSequenceLength(source)) {
      $this.bd2('Unexpected EOF during unicode escape');
    }
    return appendHex($this, source, $this.scx_1);
  }
  $this.vcx_1.fc(numberToChar((((fromHexChar($this, source, startPos) << 12) + (fromHexChar($this, source, startPos + 1 | 0) << 8) | 0) + (fromHexChar($this, source, startPos + 2 | 0) << 4) | 0) + fromHexChar($this, source, startPos + 3 | 0) | 0));
  return startPos + 4 | 0;
}
function fromHexChar($this, source, currentPosition) {
  var character = charSequenceGet(source, currentPosition);
  var tmp;
  if (_Char___init__impl__6a9atx(48) <= character ? character <= _Char___init__impl__6a9atx(57) : false) {
    // Inline function 'kotlin.code' call
    var tmp_0 = Char__toInt_impl_vasixd(character);
    // Inline function 'kotlin.code' call
    var this_0 = _Char___init__impl__6a9atx(48);
    tmp = tmp_0 - Char__toInt_impl_vasixd(this_0) | 0;
  } else if (_Char___init__impl__6a9atx(97) <= character ? character <= _Char___init__impl__6a9atx(102) : false) {
    // Inline function 'kotlin.code' call
    var tmp_1 = Char__toInt_impl_vasixd(character);
    // Inline function 'kotlin.code' call
    var this_1 = _Char___init__impl__6a9atx(97);
    tmp = (tmp_1 - Char__toInt_impl_vasixd(this_1) | 0) + 10 | 0;
  } else if (_Char___init__impl__6a9atx(65) <= character ? character <= _Char___init__impl__6a9atx(70) : false) {
    // Inline function 'kotlin.code' call
    var tmp_2 = Char__toInt_impl_vasixd(character);
    // Inline function 'kotlin.code' call
    var this_2 = _Char___init__impl__6a9atx(65);
    tmp = (tmp_2 - Char__toInt_impl_vasixd(this_2) | 0) + 10 | 0;
  } else {
    $this.bd2("Invalid toHexChar char '" + toString_1(character) + "' in unicode escape");
  }
  return tmp;
}
function consumeBoolean2($this, start) {
  var current = $this.hd7(start);
  if (current >= charSequenceLength($this.gd7()) || current === -1) {
    $this.bd2('EOF');
  }
  // Inline function 'kotlin.code' call
  var tmp = $this.gd7();
  var _unary__edvuaz = current;
  current = _unary__edvuaz + 1 | 0;
  var this_0 = charSequenceGet(tmp, _unary__edvuaz);
  var tmp42_subject = Char__toInt_impl_vasixd(this_0) | 32;
  var tmp_0;
  // Inline function 'kotlin.code' call
  var this_1 = _Char___init__impl__6a9atx(116);
  if (tmp42_subject === Char__toInt_impl_vasixd(this_1)) {
    consumeBooleanLiteral($this, 'rue', current);
    tmp_0 = true;
  } else {
    // Inline function 'kotlin.code' call
    var this_2 = _Char___init__impl__6a9atx(102);
    if (tmp42_subject === Char__toInt_impl_vasixd(this_2)) {
      consumeBooleanLiteral($this, 'alse', current);
      tmp_0 = false;
    } else {
      $this.bd2("Expected valid boolean literal prefix, but had '" + $this.vd3() + "'");
    }
  }
  return tmp_0;
}
function consumeBooleanLiteral($this, literalSuffix, current) {
  if ((charSequenceLength($this.gd7()) - current | 0) < literalSuffix.length) {
    $this.bd2('Unexpected end of boolean literal');
  }
  var inductionVariable = 0;
  var last = charSequenceLength(literalSuffix) - 1 | 0;
  if (inductionVariable <= last)
    do {
      var i = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var expected = charSequenceGet(literalSuffix, i);
      var actual = charSequenceGet($this.gd7(), current + i | 0);
      // Inline function 'kotlin.code' call
      var tmp = Char__toInt_impl_vasixd(expected);
      // Inline function 'kotlin.code' call
      if (!(tmp === (Char__toInt_impl_vasixd(actual) | 32))) {
        $this.bd2("Expected valid boolean literal prefix, but had '" + $this.vd3() + "'");
      }
    }
     while (inductionVariable <= last);
  $this.scx_1 = current + literalSuffix.length | 0;
}
function consumeNumericLiteral$calculateExponent(exponentAccumulator, isExponentPositive) {
  var tmp;
  switch (isExponentPositive) {
    case false:
      // Inline function 'kotlin.math.pow' call

      var x = -exponentAccumulator.r4();
      tmp = Math.pow(10.0, x);
      break;
    case true:
      // Inline function 'kotlin.math.pow' call

      var x_0 = exponentAccumulator.r4();
      tmp = Math.pow(10.0, x_0);
      break;
    default:
      noWhenBranchMatchedException();
      break;
  }
  return tmp;
}
function charToTokenClass(c) {
  var tmp;
  // Inline function 'kotlin.code' call
  if (Char__toInt_impl_vasixd(c) < 126) {
    var tmp_0 = CharMappings_getInstance().qd7_1;
    // Inline function 'kotlin.code' call
    tmp = tmp_0[Char__toInt_impl_vasixd(c)];
  } else {
    tmp = 0;
  }
  return tmp;
}
function tokenDescription(token) {
  return token === 1 ? "quotation mark '\"'" : token === 2 ? "string escape sequence '\\'" : token === 4 ? "comma ','" : token === 5 ? "colon ':'" : token === 6 ? "start of the object '{'" : token === 7 ? "end of the object '}'" : token === 8 ? "start of the array '['" : token === 9 ? "end of the array ']'" : token === 10 ? 'end of the input' : token === 127 ? 'invalid token' : 'valid token';
}
function escapeToChar(c) {
  return c < 117 ? CharMappings_getInstance().pd7_1[c] : _Char___init__impl__6a9atx(0);
}
function initEscape($this) {
  var inductionVariable = 0;
  if (inductionVariable <= 31)
    do {
      var i = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      initC2ESC($this, i, _Char___init__impl__6a9atx(117));
    }
     while (inductionVariable <= 31);
  initC2ESC($this, 8, _Char___init__impl__6a9atx(98));
  initC2ESC($this, 9, _Char___init__impl__6a9atx(116));
  initC2ESC($this, 10, _Char___init__impl__6a9atx(110));
  initC2ESC($this, 12, _Char___init__impl__6a9atx(102));
  initC2ESC($this, 13, _Char___init__impl__6a9atx(114));
  initC2ESC_0($this, _Char___init__impl__6a9atx(47), _Char___init__impl__6a9atx(47));
  initC2ESC_0($this, _Char___init__impl__6a9atx(34), _Char___init__impl__6a9atx(34));
  initC2ESC_0($this, _Char___init__impl__6a9atx(92), _Char___init__impl__6a9atx(92));
}
function initCharToToken($this) {
  var inductionVariable = 0;
  if (inductionVariable <= 32)
    do {
      var i = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      initC2TC($this, i, 127);
    }
     while (inductionVariable <= 32);
  initC2TC($this, 9, 3);
  initC2TC($this, 10, 3);
  initC2TC($this, 13, 3);
  initC2TC($this, 32, 3);
  initC2TC_0($this, _Char___init__impl__6a9atx(44), 4);
  initC2TC_0($this, _Char___init__impl__6a9atx(58), 5);
  initC2TC_0($this, _Char___init__impl__6a9atx(123), 6);
  initC2TC_0($this, _Char___init__impl__6a9atx(125), 7);
  initC2TC_0($this, _Char___init__impl__6a9atx(91), 8);
  initC2TC_0($this, _Char___init__impl__6a9atx(93), 9);
  initC2TC_0($this, _Char___init__impl__6a9atx(34), 1);
  initC2TC_0($this, _Char___init__impl__6a9atx(92), 2);
}
function initC2ESC($this, c, esc) {
  if (!(esc === _Char___init__impl__6a9atx(117))) {
    // Inline function 'kotlin.code' call
    var tmp$ret$0 = Char__toInt_impl_vasixd(esc);
    $this.pd7_1[tmp$ret$0] = numberToChar(c);
  }
}
function initC2ESC_0($this, c, esc) {
  // Inline function 'kotlin.code' call
  var tmp$ret$0 = Char__toInt_impl_vasixd(c);
  return initC2ESC($this, tmp$ret$0, esc);
}
function initC2TC($this, c, cl) {
  $this.qd7_1[c] = cl;
}
function initC2TC_0($this, c, cl) {
  // Inline function 'kotlin.code' call
  var tmp$ret$0 = Char__toInt_impl_vasixd(c);
  return initC2TC($this, tmp$ret$0, cl);
}
var CharMappings_instance;
function CharMappings_getInstance() {
  if (CharMappings_instance === VOID)
    new CharMappings();
  return CharMappings_instance;
}
function StringJsonLexer_0(json, source) {
  return !json.ecx_1.fcz_1 ? new StringJsonLexer(source) : new StringJsonLexerWithComments(source);
}
function get_schemaCache(_this__u8e3s4) {
  return _this__u8e3s4.gcx_1;
}
function createMapForCache(initialCapacity) {
  return HashMap.m9(initialCapacity);
}
//region block: post-declaration
initMetadataForClass(Json, 'Json');
initMetadataForObject(Default, 'Default');
initMetadataForClass(JsonBuilder, 'JsonBuilder');
initMetadataForClass(JsonImpl, 'JsonImpl');
initMetadataForClass(JsonClassDiscriminator, 'JsonClassDiscriminator');
initMetadataForClass(JsonNames, 'JsonNames');
initMetadataForClass(JsonConfiguration, 'JsonConfiguration');
initMetadataForClass(ClassDiscriminatorMode, 'ClassDiscriminatorMode');
initMetadataForInterface(JsonDecoder, 'JsonDecoder', VOID, VOID, [Decoder, CompositeDecoder]);
initMetadataForCompanion(Companion);
initMetadataForClass(JsonElement, 'JsonElement', VOID, VOID, VOID, VOID, VOID, {0: JsonElementSerializer_getInstance});
initMetadataForCompanion(Companion_0);
initMetadataForClass(JsonObject, 'JsonObject', VOID, VOID, [JsonElement, KtMap], VOID, VOID, {0: JsonObjectSerializer_getInstance});
initMetadataForClass(JsonPrimitive, 'JsonPrimitive', VOID, VOID, VOID, VOID, VOID, {0: JsonPrimitiveSerializer_getInstance});
initMetadataForObject(JsonNull, 'JsonNull', VOID, VOID, [JsonPrimitive, SerializerFactory], VOID, VOID, {0: JsonNull_getInstance});
initMetadataForCompanion(Companion_1);
initMetadataForClass(JsonLiteral, 'JsonLiteral');
initMetadataForCompanion(Companion_2);
initMetadataForClass(JsonArray, 'JsonArray', VOID, VOID, [JsonElement, KtList], VOID, VOID, {0: JsonArraySerializer_getInstance});
initMetadataForObject(JsonElementSerializer, 'JsonElementSerializer', VOID, VOID, [KSerializer]);
initMetadataForObject(JsonObjectDescriptor, 'JsonObjectDescriptor', VOID, VOID, [SerialDescriptor]);
initMetadataForObject(JsonObjectSerializer, 'JsonObjectSerializer', VOID, VOID, [KSerializer]);
initMetadataForObject(JsonArrayDescriptor, 'JsonArrayDescriptor', VOID, VOID, [SerialDescriptor]);
initMetadataForObject(JsonArraySerializer, 'JsonArraySerializer', VOID, VOID, [KSerializer]);
initMetadataForObject(JsonPrimitiveSerializer, 'JsonPrimitiveSerializer', VOID, VOID, [KSerializer]);
initMetadataForObject(JsonNullSerializer, 'JsonNullSerializer', VOID, VOID, [KSerializer]);
initMetadataForObject(JsonLiteralSerializer, 'JsonLiteralSerializer', VOID, VOID, [KSerializer]);
protoOf(defer$1).ece = get_isNullable;
protoOf(defer$1).pce = get_isInline;
protoOf(defer$1).rce = get_annotations;
initMetadataForClass(defer$1, VOID, VOID, VOID, [SerialDescriptor]);
initMetadataForInterface(JsonEncoder, 'JsonEncoder', VOID, VOID, [Encoder, CompositeEncoder]);
initMetadataForClass(Composer, 'Composer');
initMetadataForClass(ComposerForUnsignedNumbers, 'ComposerForUnsignedNumbers');
initMetadataForClass(ComposerForUnquotedLiterals, 'ComposerForUnquotedLiterals');
initMetadataForClass(ComposerWithPrettyPrint, 'ComposerWithPrettyPrint');
initMetadataForClass(JsonElementMarker, 'JsonElementMarker');
initMetadataForClass(JsonException, 'JsonException');
initMetadataForClass(JsonEncodingException, 'JsonEncodingException');
initMetadataForClass(JsonDecodingException, 'JsonDecodingException');
initMetadataForObject(Tombstone, 'Tombstone');
initMetadataForClass(JsonPath, 'JsonPath', JsonPath);
initMetadataForLambda(JsonTreeReader$readDeepRecursive$slambda, VOID, VOID, [2]);
initMetadataForClass(JsonTreeReader, 'JsonTreeReader', VOID, VOID, VOID, [0]);
protoOf(PolymorphismValidator).xcw = contextual;
initMetadataForClass(PolymorphismValidator, 'PolymorphismValidator', VOID, VOID, [SerializersModuleCollector]);
initMetadataForClass(Key, 'Key', Key);
initMetadataForClass(DescriptorSchemaCache, 'DescriptorSchemaCache', DescriptorSchemaCache);
initMetadataForClass(DiscriminatorHolder, 'DiscriminatorHolder');
initMetadataForClass(StreamingJsonDecoder, 'StreamingJsonDecoder', VOID, VOID, [JsonDecoder, AbstractDecoder]);
initMetadataForClass(JsonDecoderForUnsignedTypes, 'JsonDecoderForUnsignedTypes');
initMetadataForClass(StreamingJsonEncoder, 'StreamingJsonEncoder', VOID, VOID, [JsonEncoder, AbstractEncoder]);
initMetadataForClass(AbstractJsonTreeDecoder, 'AbstractJsonTreeDecoder', VOID, VOID, [NamedValueDecoder, JsonDecoder]);
initMetadataForClass(JsonTreeDecoder, 'JsonTreeDecoder');
initMetadataForClass(JsonTreeListDecoder, 'JsonTreeListDecoder');
initMetadataForClass(JsonPrimitiveDecoder, 'JsonPrimitiveDecoder');
initMetadataForClass(JsonTreeMapDecoder, 'JsonTreeMapDecoder');
initMetadataForClass(WriteMode, 'WriteMode');
initMetadataForClass(AbstractJsonLexer, 'AbstractJsonLexer');
initMetadataForObject(CharMappings, 'CharMappings');
initMetadataForClass(StringJsonLexer, 'StringJsonLexer');
initMetadataForClass(StringJsonLexerWithComments, 'StringJsonLexerWithComments');
initMetadataForClass(JsonToStringWriter, 'JsonToStringWriter', JsonToStringWriter);
//endregion
//region block: init
Companion_instance = new Companion();
Companion_instance_0 = new Companion_0();
Companion_instance_1 = new Companion_1();
Companion_instance_2 = new Companion_2();
Tombstone_instance = new Tombstone();
//endregion
//region block: exports
export {
  Json_0 as Jsonsmkyu9xjl7fv,
};
//endregion
